import _defineProperty from "babel-runtime/helpers/defineProperty";

var _headers;

/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable no-loop-func */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-const-assign */
/* eslint-disable promise/always-return */
/* eslint-disable shopify/jquery-dollar-sign-reference */
/* eslint-disable promise/no-nesting */
/* eslint-disable promise/catch-or-return */
/* eslint-disable eqeqeq */
/**
 * Cart methods
 * -----------------------------------------------------------------------------
 *
 * @namespace cart
 */

import axios from 'axios';
// date picker component
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moment from 'moment';
import { find } from 'filepond';
import Flickity from 'flickity';

// IE11 bug: we need to disable cache for this request
var axiosConfig = {
  headers: (_headers = {
    'Cache-Control': 'must-revalidate'
  }, _defineProperty(_headers, "Cache-Control", 'no-cache'), _defineProperty(_headers, "Cache-Control", 'no-store'), _defineProperty(_headers, "Pragma", 'no-cache'), _headers)
};

var cartMethods = {
  components: {
    flatPickr: flatPickr
  },

  data: function data() {
    return {
      isCartAjaxed: false,
      loadingEvent: null,
      cart: {},
      cartError: false,
      cartinViewport: false,
      // shipping calculator
      countries: window.Countries,
      provinces: null,
      selectedCountry: null,
      selectedProvince: null,
      selectedZip: null,
      zipRequired: false,
      shippingRates: null,
      shippingRatesErrors: null,

      // date picker
      // get more from https://chmln.github.io/flatpickr/options/
      datePickerConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'm-d-Y',
        enableTime: false,
        locale: {
          firstDayOfWeek: 1 // start week on Monday
        },
        // minDate: "today",
        minDate: new Date().fp_incr(2), // 2 days from now

        // disable Saturdays and Sundays - disable using a function
        disable: [function (date) {
          // must return true to disable
          return date.getDay() === 6 || date.getDay() === 0;
        }]
      }
    };
  },


  watch: {
    selectedCountry: function selectedCountry() {
      var selectedCountryObj = app.countries[app.selectedCountry];
      var selectedProvincesObj = selectedCountryObj.province_alternate_names;
      var provincesLength = Object.keys(selectedProvincesObj).length;

      // clear data
      app.shippingRates = null;
      app.shippingRatesErrors = null;
      app.selectedZip = null;

      // set data
      app.zipRequired = selectedCountryObj.zip_required;

      if (provincesLength > 0) {
        app.provinces = selectedProvincesObj;
        // app.selectedProvince = Object.keys(app.provinces)[0]
      } else {
        app.provinces = null;
      }
    }
  },

  methods: {
    _initCart: function _initCart() {
      var isCartAjaxed = $('[data-template="cart"]').data('cart-ajaxed');

      if (isCartAjaxed) {
        app.isCartAjaxed = true;
      }

      app._getCartData();
      app._isInViewport();

      if (app._getCookie("selectedComuna") != "selectedComuna" && app._getCookie("selectedComuna") != '' && app._getCookie("selectedComuna") != null) {
        app.selectedComuna = app._getCookie("selectedComuna");
        app.selectedRegion = app._getCookie("selectedRegion");
      }

      if (app.currentTemplate == 'cart') {
        var cartData = [];
        setTimeout(function () {
          $(app.cart.items).each(function (index, item) {
            cartData.push({ //  adding a product to a shopping cart.
              name: item.product_title,
              id: item.id,
              price: app._formatMoney(item.price),
              sku: item.sku,
              brand: item.vendor,
              category: item.product_type,
              variant: item.variant_title,
              quantity: item.quantity
            });
          });

          dataLayer.push({
            event: 'cartView',
            ecommerce: {
              currencyCode: 'CLP',
              add: { // 'add' actionFieldObject measures.
                products: cartData
              }
            }
          });

          app._checkComunaOnLoad();
        }, 2000);

        var autocomplete = void 0;
        var address1Field = void 0;
        var address2Field = void 0;
        var postalField = void 0;
        setTimeout(function () {
          app._initAutocomplete();
          if (window.innerWidth < 768) {
            $('.checkout-box .mob-toggle').click(function () {
              $(this).parents('.checkout-box').find('.order-checkout').toggleClass('show');
            });
          }
        }, 3000);

        setTimeout(function () {
          $(document).click(function (event) {
            if ($('.datepicker-cart').is(':visible')) {
              $('.datepicker-cart').hide();
            }

            if (!$(event.target).closest('#modalForShipping.modal, a.selected-communa').length) {
              $('#modalForShipping').modal('hide');
            }
          });
        }, 9000);

        setInterval(function () {
          if (app.freeShippingEnabled && $.trim($('.total_shipping_price h6 span').text()) == '$0') {
            $('.ship_price').text('$0');
          }
        }, 1000);
      }

      setTimeout(function () {
        $('.card.haswarranty').each(function () {
          var rem_div = $(this).attr('data-waranty-qty');
          if (rem_div > 1) {
            var rem_div_qty = rem_div - 1;
            // $(this).parents('.extended-warranty').find('.card.haswarranty[data-waranty-qty="'+rem_div+'"]').slice(1, rem_div_qty).remove();
            $(this).parents('.extended-warranty').find(".card.haswarranty[data-waranty-qty=\"" + rem_div + "\"]:nth-child(" + rem_div_qty + ")").attr('must_remove', 'yes');
            // var indexwar = $(this).parents('.extended-warranty').find('.card.haswarranty[data-waranty-qty="'+rem_div+'"]').index() + 1;
            $(this).parents('.extended-warranty').find(".card.haswarranty[data-waranty-qty=\"" + rem_div + "\"]").nextAll(":lt(" + rem_div_qty + ")").remove();
            $(this).removeClass('haswarranty');
          }
        });
      }, 2000);

      $('body').on('click', '.installation-after label, .installation-before label', function () {
        $(this).find('a')[0].click();
      });

      $('body').on('click', '[data-checkout-click]', function () {

        var chkcount = 0;
        app.cart.items.forEach(function (item, index) {
          if (item.properties) {
            if (!item.properties.delivery_date || item.properties.delivery_date == '' || item.properties.delivery_date == null) {
              chkcount = 1;
            }
          }
        });

        var title = 'Falta la fecha de entrega';
        if (chkcount == 1) {
          app.$snotify.error(title, 'Error', {
            timeout: 5000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            titleMaxLength: 50,
            icon: 'https://cdn.shopify.com/s/files/1/0104/4391/5319/files/danger.png?v=1624358532',
            buttons: [{
              text: 'Cerrar',
              bold: true,
              closeOnClick: true
            }]
          });
        }

        if (app.selectedRegion != null && app.selectedComuna != null && app.selectedRegion != '' && app.selectedComuna != '') {

          $(this).html('<span class="spinner-border-custom" role="status" aria-hidden="true"></span>');

          if (app._getCookie('selectedTimestamp') && app._getCookie('selectedTimestamp') != undefined && app._getCookie('selectedTimestamp') != '' && app._getCookie('selectedTimestamp') != 'selectedTimestamp') {

            // eslint-disable-next-line radix
            var selectedTS = parseInt(app._getCookie('selectedTimestamp'));
            var currentTS = new Date().getTime();
            var difference = currentTS - selectedTS;

            var daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
            var hoursDifference = Math.floor(difference / 1000 / 60 / 60);
            difference -= daysDifference * 1000 * 60 * 60 * 24;

            if (hoursDifference > 12) {
              document.cookie = 'selCommonC=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
              document.cookie = 'selCommonR=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
              document.cookie = 'selectedComuna=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
              document.cookie = 'selectedRegion=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
              document.cookie = 'selectedaddress1=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
              document.cookie = 'selectedaddress2=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
              // app.selectedRegion = null;
              // app.selectedComuna = null;
              $.post('/cart.js', {
                attributes: {
                  Region: '',
                  Comuna: ''
                }
              }).done(function () {
                location.reload();
              });
            } else {
              var ttl_ship_index = 0;
              var same_day_check = 0;
              var same_day_check_id = 0;
              var same_day_check_date = 0;
              app.cart.items.forEach(function (item, index) {
                if (app.cart.items[index].properties.total_shipping && app.cart.items[index].properties.total_shipping != '' && app.cart.items[index].properties.total_shipping != null) {
                  ttl_ship_index = index;
                }
                if (app.cart.items[index].properties.same_day_delivery_option == 'true') {
                  same_day_check = index;
                  same_day_check_id = app.cart.items[index].id;
                  same_day_check_date = app.cart.items[index].properties.delivery_date;
                }
              });

              var today = moment();
              today = today.format('YYYY') + '-' + today.format('MM') + '-' + today.format('DD');
              var currentTime = moment();
              var endTime = moment('13:00 pm', 'HH:mm a');
              // currentTime.hour() >= endTime.hour()
              if (same_day_check_id != 0 && same_day_check_date == today && currentTime.hour() >= endTime.hour()) {
                var _array = [];
                var _tempArray = app.cart.items;
                _tempArray.forEach(function (item, index) {
                  for (var subitem in item) {
                    if (subitem != 'id' && subitem != 'properties' && subitem != 'quantity' && subitem != 'variant_id' && subitem != 'vendor' && subitem != 'requires_shipping' && subitem != 'product_type') {
                      delete item[subitem];
                    }
                  }
                });

                _array = _tempArray;
                var shipping_type_1 = 'delivery';
                var contains = { items: _array };
                var location_id_1 = 'null';
                var _valReg = app.selectedRegion;
                var _valCom = app.selectedComuna;
                var dataConfigSm = {
                  location_id: location_id_1,
                  shipping_type: shipping_type_1,
                  region: _valReg,
                  district: _valCom,
                  cart: JSON.stringify(contains),
                  date_count: 1,
                  change_shipping_type: 0,
                  change_comuna: 1
                };

                var _ajax_url = void 0;
                if (app.freeShippingEnabled) {
                  _ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
                } else {
                  _ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
                }

                $.ajax({
                  type: 'POST',
                  url: _ajax_url,
                  dataType: 'json',
                  data: dataConfigSm,
                  success: function success(data) {
                    if (data.errors) {
                      setTimeout(function () {
                        location.reload();
                      }, 2500);
                      return false;
                    }
                    var setTimeFinal = 0;
                    data.forEach(function (item, index) {
                      var shipping_type = item.type;
                      var tempSamProperties = {};
                      var thisVarid = item.id;
                      var thisItem = app.cart.items.find(function (item) {
                        return parseInt(item.variant_id) === parseInt(thisVarid);
                      });
                      var line = 0;
                      app.cart.items.forEach(function (item, index) {
                        if (parseInt(item.id) == parseInt(thisVarid)) {
                          line = index;
                        }
                      });
                      var lineitem = line + 1;
                      var dataConfigSm2 = {
                        quantity: thisItem.quantity,
                        line: lineitem,
                        properties: ''
                      };
                      tempSamProperties = thisItem.properties;

                      if (shipping_type == 'preorder') {
                        tempSamProperties['delivery_date'] = item.start_date;
                      } else if (shipping_type == 'marketplace') {
                        tempSamProperties['delivery_date'] = item.delivery_date;
                      } else {
                        if (shipping_type == 'pickup') {
                          var ship_pick_dates = item.pickup_dates;
                          var selShipdateArray = $.map(ship_pick_dates, function (_element, index) {
                            return index;
                          });
                          var selShipdate = selShipdateArray.toString();
                        } else {
                          var ship_pick_dates = item.shipping_dates;
                          var selShipdateArray = $.map(ship_pick_dates, function (element, index) {
                            return index;
                          });
                          var selShipdate = selShipdateArray.toString();
                          var selFullfilldate = ship_pick_dates[selShipdate].fulfilment_date;
                        }
                        tempSamProperties['delivery_date'] = selShipdate;
                      }

                      dataConfigSm2.properties = tempSamProperties;
                      var setTime = index * 500;
                      setTimeFinal = index * 500 + 300;
                      setTimeout(function () {
                        jQuery.ajax({
                          url: '/cart/change.js',
                          dataType: 'json',
                          data: dataConfigSm2
                        }).done(function (rep) {
                          console.log(rep);
                          return false;
                        });
                      }, setTime);
                    });
                    setTimeout(function () {
                      location.reload();
                    }, setTimeFinal + 500);
                  }
                });
                return false;
              }

              var tempProperties = {};
              var dataN = {
                line: ttl_ship_index + 1,
                properties: ''
              };

              tempProperties = app.cart.items[ttl_ship_index].properties;
              var total_ship_val = 0;
              if ($('.main_ship').length > 0) {
                $('.main_ship').each(function () {
                  total_ship_val += parseFloat($(this).find('.ship_price span').text());
                });
              }

              if (window.theme.offerFreeShipEnabled && window.theme.offerFreeShipAmount != '' && parseFloat(window.theme.offerFreeShipAmount) <= parseFloat(app.cart.total_price / 100000)) {
                tempProperties.total_shipping = '0';
              } else {
                tempProperties.total_shipping = total_ship_val;
              }

              // tempProperties['is_staging'] = true;

              dataN.quantity = app.cart.items[ttl_ship_index].quantity;
              dataN.properties = tempProperties;

              jQuery.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                data: dataN
              }).done(function (rep) {
                app._getCartData();
                setTimeout(function () {
                  if (app.selectedComuna != null && app.selectedRegion != null) {
                    $.post('/cart.js', {
                      attributes: {
                        Region: app.selectedRegion,
                        Comuna: app.selectedComuna
                      }
                    }).done(function () {
                      document.cookie = 'tempaddress1=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                      window.location.href = '/checkout?step=contact_information';
                    });
                  }
                }, 500);
              });

              var _cartData = [];
              $(app.cart.items).each(function (_index, item) {
                _cartData.push({ //  adding a product to a shopping cart.
                  name: item.product_title,
                  id: item.id,
                  price: app._formatMoney(item.price),
                  sku: item.sku,
                  brand: item.vendor,
                  category: item.product_type,
                  variant: item.variant_title,
                  quantity: item.quantity
                });
              });

              dataLayer.push({
                event: 'begin_checkout',
                ecommerce: {
                  currencyCode: 'CLP',
                  add: { // 'add' actionFieldObject measures.
                    products: _cartData
                  }
                }
              });
            }
          } else {
            document.cookie = 'selCommonC=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'selCommonR=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'selectedaddress1=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'selectedaddress2=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            // app.selectedRegion = null;
            // app.selectedComuna = null;
            $.post('/cart.js', {
              attributes: {
                Region: '',
                Comuna: ''
              }
            }).done(function () {
              location.reload();
            });
          }
        } else {
          $('.msg-reg-com').removeClass('d-none');
        }
      });

      $('body').on('click', '.no-direction', function () {
        $('.div-autocomp').removeClass('show-autocon').hide();
        $('.div-none-autocomp').addClass('show-autocon').fadeIn(300);
        $('.back-direction').addClass('show');
        $('.no-direction').removeClass('show');

        $('.numeric_error, .addlength_erro, .numeric_only_error').addClass('d-none');

        $('[data-regions], [data-district]').removeAttr('disabled');
        $('.show-autocon #checkout_verify_address').parents('.checkbox-wrapper').removeClass('checkbox_error');
        if ($('.show-autocon #checkout_verify_address').prop('checked') == true && $('.show-autocon .checkbox-wrapper').is(':visible') && $('.show-autocon .numeric_error').is(':visible') == false && $('.show-autocon .numeric_only_error').is(':visible') == false) {
          $('.button-overlay').addClass('d-none');
        } else {
          $('.button-overlay').removeClass('d-none');
        }

        $('#ship-address-noa').val($('#ship-address').val());
      });

      $('body').on('click', '.back-direction', function () {
        $('.div-none-autocomp').removeClass('show-autocon').hide();
        $('.div-autocomp').addClass('show-autocon').fadeIn(300);
        $('.no-direction').addClass('show');
        $('.back-direction').removeClass('show');

        $('#ship-address').val('');
        $('[data-shipping-check]').addClass('button-hidden');

        $('.numeric_error, .addlength_erro, .numeric_only_error').addClass('d-none');
      });

      // shipping calculator
      app._initShippingCalculator();
      $(window).on('load scroll', function () {
        app._isInViewport();
      });

      // var isALARendered;
      if (app._getCookie('selFromCheckout') && app._getCookie('selFromCheckout') == 1) {
        app._ALAcheck();
      }

      setTimeout(function () {
        if (app.currentTemplate == 'cart' && app.cart.item_count > 0) {
          var chkcountN = 0;
          app.cart.items.forEach(function (item, index) {
            if (item.properties) {
              if (!item.properties.delivery_date || item.properties.delivery_date == '' || item.properties.delivery_date == null) {
                chkcountN = 1;
              }
            }
          });
          if (chkcountN == 1) {
            document.cookie = 'selectedComuna=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'selectedRegion=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'selCommonC=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'selCommonR=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            app.selectedComuna = '';
            app.selectedRegion = '';
          }

          if (app._getCookie("selectedComuna") == "selectedComuna" || app._getCookie("selectedComuna") == null || app._getCookie("selectedComuna") == '') {
            app._openModelNew();
            $("#modalForShippingHomeCol .close").hide();
          }
        }
      }, 2000), setTimeout(function () {
        // if ($('#modalForShipping').hasClass('show') == false && app.currentTemplate == 'cart' && $('[data-installation-available]').length > 0) {
        //   if ($('[data-regions]').val() !== 'Región Metropolitana') {
        //     $('#modalWarningInsPrd').modal('show');
        //   } else {
        //     $('#modalWarningInsPrd').modal('hide');
        //   }
        // }
      }, 3500);

      if (app.currentTemplate == 'product') {
        document.addEventListener('rebuy.beforeShow', function (event) {
          if (event.detail.widget.element._prevClass == 'rebuy-cross-sell-products' || event.detail.widget.element._prevClass == 'rebuy-upsell-products') {
            if ($('.' + event.detail.widget.element._prevClass).find('.widget-display-popup').hasClass('is-hidden')) {
              $('.' + event.detail.widget.element._prevClass).find('.widget-display-popup').removeClass('is-hidden').addClass('is-visible');
              $('.' + event.detail.widget.element._prevClass).find('.widget-display-popup ').removeClass('is-hidden').addClass('is-visible');
            }
          }
          var openWidgetData = event.detail.widget.data.products;

          setTimeout(function () {
            if (event.detail.widget.element._prevClass == 'rebuy-cross-sell-products' || event.detail.widget.element._prevClass == 'rebuy-upsell-products') {
              var justAddedPrdHtml = '';
              justAddedPrdHtml += '<div class="rebuy-just-added pt-md-2">';
              justAddedPrdHtml += '<div class="row mx-sm-n3 mx-n2">';
              justAddedPrdHtml += '<div class="col-xl-6 col-md-8 col-12 px-sm-3 px-2">';
              justAddedPrdHtml += '<div class="row mx-sm-n3 mx-n2" style="align-items: center;">';
              justAddedPrdHtml += '<div class="col-xl-3 col-sm-4 col-3 px-sm-3 px-2">';
              justAddedPrdHtml += '<div class="cart-product-wrapper">';
              justAddedPrdHtml += '<a href="javascript:void(0);">';
              if (app.cart.items[0].handle != 'grill-assembly-service' && app.cart.items[0].handle != 'horno-elite-touch-instalacion') {
                if (app.cart.items[0].image != null) {
                  justAddedPrdHtml += '<img src="' + app.cart.items[0].image + '" alt="' + app.cart.items[0].product_title + '" class="img-fluid item-img">';
                } else {
                  justAddedPrdHtml += '<img src="https://cdn.shopify.com/s/files/1/0104/4391/5319/files/kitchencenter_logo.svg?6927" alt="' + app.cart.items[0].product_title + '" class="img-fluid item-img">';
                }
              } else {
                if (app.cart.items[1].image != null) {
                  justAddedPrdHtml += '<img src="' + app.cart.items[1].image + '" alt="' + app.cart.items[1].product_title + '" class="img-fluid item-img">';
                } else {
                  justAddedPrdHtml += '<img src="https://cdn.shopify.com/s/files/1/0104/4391/5319/files/kitchencenter_logo.svg?6927" alt="' + app.cart.items[1].product_title + '" class="img-fluid item-img">';
                }
              }
              justAddedPrdHtml += '</a>';
              justAddedPrdHtml += '</div>';
              justAddedPrdHtml += '</div>';
              justAddedPrdHtml += '<div class="col-xl-9 col-sm-8 col-9 px-sm-3 px-2">';
              justAddedPrdHtml += '<div class="row mx-sm-n3 mx-n2">';
              justAddedPrdHtml += '<div class="col-xl-6 col-6 px-sm-3 px-2">';
              justAddedPrdHtml += '<a href="javascript:void(0);" class="text-gray-900 font-weight-medium letter-spacing lead mb-2">';
              if (app.cart.items[0].handle != 'grill-assembly-service' && app.cart.items[0].handle != 'horno-elite-touch-instalacion') {
                justAddedPrdHtml += '<h5 class="font-family-base font-weight-medium mb-1">' + app.cart.items[0].product_title + '</h5>';
              } else {
                justAddedPrdHtml += '<h5 class="font-family-base font-weight-medium mb-1">' + app.cart.items[1].product_title + '</h5>';
              }
              if (app.cart.items[0].handle != 'grill-assembly-service' && app.cart.items[0].handle != 'horno-elite-touch-instalacion') {
                justAddedPrdHtml += '<p class="text-uppercase mb-0">' + app.cart.items[0].vendor + '</p>';
              } else {
                justAddedPrdHtml += '<p class="text-uppercase mb-0">' + app.cart.items[1].vendor + '</p>';
              }
              if (app.cart.items[0].handle != 'grill-assembly-service' && app.cart.items[0].handle != 'horno-elite-touch-instalacion') {
                justAddedPrdHtml += '<p class=" text-gray-500 mb-0 ">SKU: ' + app.cart.items[0].sku + '</p>';
              } else {
                justAddedPrdHtml += '<p class=" text-gray-500 mb-0 ">SKU: ' + app.cart.items[1].sku + '</p>';
              }
              justAddedPrdHtml += '</a>';
              justAddedPrdHtml += '</div>';
              justAddedPrdHtml += '<div class="col-xl-6 col-6 px-sm-3 px-2">';
              if (app.cart.items[0].handle != 'grill-assembly-service' && app.cart.items[0].handle != 'horno-elite-touch-instalacion') {
                justAddedPrdHtml += '<h5 class="cart-price mt-2 font-family-base font-weight-medium letter-spacing-normal amount text-right heading-mobile-size">' + app._formatMoney(app.cart.items[0].final_line_price) + '</h5>';
              } else {
                justAddedPrdHtml += '<h5 class="cart-price mt-2 font-family-base font-weight-medium letter-spacing-normal amount text-right heading-mobile-size">' + app._formatMoney(app.cart.items[1].final_line_price) + '</h5>';
              }
              if (event.detail.widget.element._prevClass == 'rebuy-cross-sell-products') {
                justAddedPrdHtml += '<div class="cart-product-details pl-xl-3">';
                justAddedPrdHtml += '<div class="cart-quantity mb-1">';
                justAddedPrdHtml += '<div data-qty-container="" class="quantity-wrapper quantity-wrapper-sm">';
                justAddedPrdHtml += '<div class="input-group input-group-sm">';
                justAddedPrdHtml += '<div class="input-group-prepend">';
                if (app.cart.items[0].handle != 'grill-assembly-service' && app.cart.items[0].handle != 'horno-elite-touch-instalacion') {
                  justAddedPrdHtml += '<a href="javascript:void(0);" rel="nofollow" aria-label="Decrease" title="Decrease" data-qty-decrease="" class="input-group-text bg-transparent p-1 justify-content-center" onclick="app._updateCart(1, event)">';
                } else {
                  justAddedPrdHtml += '<a href="javascript:void(0);" rel="nofollow" aria-label="Decrease" title="Decrease" data-qty-decrease="" class="input-group-text bg-transparent p-1 justify-content-center" onclick="app._updateCart(2, event)">';
                }
                justAddedPrdHtml += '<span class="btn-decrease w-100">';
                justAddedPrdHtml += '<i class="icon-kc icon-size-xs icon-qty-minus-cart"></i>';
                justAddedPrdHtml += '</span>';
                justAddedPrdHtml += '</a>';
                justAddedPrdHtml += '</div>';
                if (app.cart.items[0].handle != 'grill-assembly-service' && app.cart.items[0].handle != 'horno-elite-touch-instalacion') {
                  justAddedPrdHtml += '<input type="number" name="updates[]" id="updates_' + app.cart.items[0].key + '" aria-label="quantity" step="1" min="1" inputmode="numeric" data-qty-input="" class="quantity form-control text-center bg-white text-black font-weight-bold lead h-auto rounded-0" value="' + app.cart.items[0].quantity + '" onchange="app._updateCart(1, event)">';
                } else {
                  justAddedPrdHtml += '<input type="number" name="updates[]" id="updates_' + app.cart.items[1].key + '" aria-label="quantity" step="1" min="1" inputmode="numeric" data-qty-input="" class="quantity form-control text-center bg-white text-black font-weight-bold lead h-auto rounded-0" value="' + app.cart.items[1].quantity + '" onchange="app._updateCart(2, event)">';
                }
                justAddedPrdHtml += '<div data-inventory="936" class="input-group-append">';
                if (app.cart.items[0].handle != 'grill-assembly-service' && app.cart.items[0].handle != 'horno-elite-touch-instalacion') {
                  justAddedPrdHtml += '<a href="javascript:void(0);" rel="nofollow" aria-label="Increase" title="Increase" data-qty-increase="" class="input-group-text bg-transparent p-1 justify-content-center" onclick="app._updateCart(1, event)">';
                } else {
                  justAddedPrdHtml += '<a href="javascript:void(0);" rel="nofollow" aria-label="Increase" title="Increase" data-qty-increase="" class="input-group-text bg-transparent p-1 justify-content-center" onclick="app._updateCart(2, event)">';
                }
                justAddedPrdHtml += '<span class="btn-increase">';
                justAddedPrdHtml += '<i class="icon-kc icon-size-xs icon-qty-add-cart"></i>';
                justAddedPrdHtml += '</span>';
                justAddedPrdHtml += '</a>';
                justAddedPrdHtml += '</div>';
                justAddedPrdHtml += '</div>';
                justAddedPrdHtml += '</div>';
                justAddedPrdHtml += '</div>';
                justAddedPrdHtml += '</div>';
              }
              justAddedPrdHtml += '</div>';
              justAddedPrdHtml += '</div>';
              justAddedPrdHtml += '</div>';
              justAddedPrdHtml += '</div>';
              justAddedPrdHtml += '</div>';
              justAddedPrdHtml += '</div>';
              justAddedPrdHtml += '<div class="divider"></div>';
              justAddedPrdHtml += '</div>';

              if ($('.rebuy-just-added').length > 0) {
                $('.rebuy-just-added').remove();
              }
              if ($('.rebuy-cross-sell-products .right_icon').length > 0) {
                $('.rebuy-cross-sell-products .right_icon').remove();
              }

              $('.rebuy-cross-sell-products .rebuy-widget-content h3').prepend('<span class="right_icon"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 0.875C17.7113 0.9725 20.8022 2.25656 23.2728 4.72719C25.7434 7.19781 27.0275 10.2887 27.125 14C27.0275 17.7113 25.7434 20.8022 23.2728 23.2728C20.8022 25.7434 17.7113 27.0275 14 27.125C10.2887 27.0275 7.19781 25.7434 4.72719 23.2728C2.25656 20.8022 0.9725 17.7113 0.875 14C0.9725 10.2887 2.25656 7.19781 4.72719 4.72719C7.19781 2.25656 10.2887 0.9725 14 0.875ZM12.3594 16.5781L9.45875 13.6775C9.22437 13.4625 8.95594 13.355 8.65344 13.355C8.35094 13.355 8.08719 13.4672 7.86219 13.6916C7.63719 13.9159 7.525 14.1747 7.52562 14.4678C7.52625 14.7609 7.63375 15.0247 7.84812 15.2591L9.70859 17.1195L11.5691 18.98C11.7841 19.195 12.0478 19.3025 12.3603 19.3025C12.6728 19.3025 12.9366 19.195 13.1516 18.98L20.8569 11.2747C21.15 10.9816 21.2428 10.625 21.1353 10.205C21.0278 9.785 20.7641 9.52125 20.3441 9.41375C19.9241 9.30625 19.5675 9.39906 19.2744 9.69219L12.3594 16.5781Z" fill="#84AE4F"/><path d="M14 0.875C17.7113 0.9725 20.8022 2.25656 23.2728 4.72719C25.7434 7.19781 27.0275 10.2887 27.125 14C27.0275 17.7113 25.7434 20.8022 23.2728 23.2728C20.8022 25.7434 17.7113 27.0275 14 27.125C10.2887 27.0275 7.19781 25.7434 4.72719 23.2728C2.25656 20.8022 0.9725 17.7113 0.875 14C0.9725 10.2887 2.25656 7.19781 4.72719 4.72719C7.19781 2.25656 10.2887 0.9725 14 0.875ZM12.3594 16.5781L9.45875 13.6775C9.22437 13.4625 8.95594 13.355 8.65344 13.355C8.35094 13.355 8.08719 13.4672 7.86219 13.6916C7.63719 13.9159 7.525 14.1747 7.52562 14.4678C7.52625 14.7609 7.63375 15.0247 7.84812 15.2591L9.70859 17.1195L11.5691 18.98C11.7841 19.195 12.0478 19.3025 12.3603 19.3025C12.6728 19.3025 12.9366 19.195 13.1516 18.98L20.8569 11.2747C21.15 10.9816 21.2428 10.625 21.1353 10.205C21.0278 9.785 20.7641 9.52125 20.3441 9.41375C19.9241 9.30625 19.5675 9.39906 19.2744 9.69219L12.3594 16.5781Z" fill="#84AE4F"/></svg></span>');

              if ($('.rebuy-upsell-products .right_icon').length > 0) {
                $('.rebuy-upsell-products .right_icon').remove();
              }
              $('.rebuy-upsell-products .rebuy-widget-content h3').prepend('<span class="right_icon"><svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 0.875C17.7113 0.9725 20.8022 2.25656 23.2728 4.72719C25.7434 7.19781 27.0275 10.2887 27.125 14C27.0275 17.7113 25.7434 20.8022 23.2728 23.2728C20.8022 25.7434 17.7113 27.0275 14 27.125C10.2887 27.0275 7.19781 25.7434 4.72719 23.2728C2.25656 20.8022 0.9725 17.7113 0.875 14C0.9725 10.2887 2.25656 7.19781 4.72719 4.72719C7.19781 2.25656 10.2887 0.9725 14 0.875ZM12.3594 16.5781L9.45875 13.6775C9.22437 13.4625 8.95594 13.355 8.65344 13.355C8.35094 13.355 8.08719 13.4672 7.86219 13.6916C7.63719 13.9159 7.525 14.1747 7.52562 14.4678C7.52625 14.7609 7.63375 15.0247 7.84812 15.2591L9.70859 17.1195L11.5691 18.98C11.7841 19.195 12.0478 19.3025 12.3603 19.3025C12.6728 19.3025 12.9366 19.195 13.1516 18.98L20.8569 11.2747C21.15 10.9816 21.2428 10.625 21.1353 10.205C21.0278 9.785 20.7641 9.52125 20.3441 9.41375C19.9241 9.30625 19.5675 9.39906 19.2744 9.69219L12.3594 16.5781Z" fill="#84AE4F"/><path d="M14 0.875C17.7113 0.9725 20.8022 2.25656 23.2728 4.72719C25.7434 7.19781 27.0275 10.2887 27.125 14C27.0275 17.7113 25.7434 20.8022 23.2728 23.2728C20.8022 25.7434 17.7113 27.0275 14 27.125C10.2887 27.0275 7.19781 25.7434 4.72719 23.2728C2.25656 20.8022 0.9725 17.7113 0.875 14C0.9725 10.2887 2.25656 7.19781 4.72719 4.72719C7.19781 2.25656 10.2887 0.9725 14 0.875ZM12.3594 16.5781L9.45875 13.6775C9.22437 13.4625 8.95594 13.355 8.65344 13.355C8.35094 13.355 8.08719 13.4672 7.86219 13.6916C7.63719 13.9159 7.525 14.1747 7.52562 14.4678C7.52625 14.7609 7.63375 15.0247 7.84812 15.2591L9.70859 17.1195L11.5691 18.98C11.7841 19.195 12.0478 19.3025 12.3603 19.3025C12.6728 19.3025 12.9366 19.195 13.1516 18.98L20.8569 11.2747C21.15 10.9816 21.2428 10.625 21.1353 10.205C21.0278 9.785 20.7641 9.52125 20.3441 9.41375C19.9241 9.30625 19.5675 9.39906 19.2744 9.69219L12.3594 16.5781Z" fill="#84AE4F"/></svg></span>');
              $('.rebuy-cross-sell-products .rebuy-widget-content h3').after(justAddedPrdHtml);
              $('.rebuy-upsell-products .rebuy-widget-content h3').after(justAddedPrdHtml);
            }
          }, 700);

          if ($('.rebuy-cross-sell-products .rebuy-button.decline').length > 0) {
            $('.rebuy-cross-sell-products .rebuy-button.decline').remove();
          }
          $('.rebuy-cross-sell-products .rebuy-product-grid').after('<button type="button" class="rebuy-button decline" tabindex="0" onclick="app._hideRebuyPopup(event)"><span>NO, GRACIAS</span></button>');

          if ($('.rebuy-upsell-products .rebuy-button.decline').length > 0) {
            $('.rebuy-upsell-products .rebuy-button.decline').remove();
          }
          $('.rebuy-upsell-products .rebuy-product-actions').before('<button type="button" class="rebuy-button decline" tabindex="0" onclick="app._hideRebuyPopup(event)"><span>NO, GRACIAS</span></button>');

          if (event.detail.widget.element._prevClass == 'rebuy-upsell-products') {
            if ($('.' + event.detail.widget.element._prevClass + ' .rebuy-product-info .rebuy_wrap').length == 0) {
              $('.' + event.detail.widget.element._prevClass + ' .rebuy-button.decline,.' + event.detail.widget.element._prevClass + ' .rebuy-product-actions ').wrapAll('<div class="rebuy_wrap d-flex w-100"></div>');

              $(".rebuy-upsell-products .rebuy_wrap").clone().appendTo(".rebuy-upsell-products .rebuy-product-info");

              $(".rebuy-upsell-products .rebuy-product-block > .rebuy_wrap").remove();
            }
          }

          // $( ".rebuy-upsell-products .rebuy_wrap" ).clone().appendTo( ".rebuy-upsell-products .rebuy-product-info" );
          // $( ".rebuy-upsell-products .rebuy-product-block > .rebuy_wrap" ).remove();

          if (event.detail.widget.element._prevClass == 'rebuy-upsell-products') {
            var upsellProduct = event.detail.widget.data.products[0];

            if ($('.rebuy-upsell-products .rebuy-product-vendor').length > 0) {
              $('.rebuy-upsell-products .rebuy-product-vendor').remove();
            }
            $('.rebuy-upsell-products .rebuy-product-info').prepend('<p class="rebuy-product-vendor mb-0">' + upsellProduct.vendor + '</p>');

            if ($('.rebuy-upsell-products .rebuy-product-sku').length > 0) {
              $('.rebuy-upsell-products .rebuy-product-sku').remove();
            }
            $('.rebuy-upsell-products .rebuy-product-title').after('<p class="rebuy-product-sku font-size-ex-sm text-gray-500 mb-0 small-size-mb">SKU: ' + upsellProduct.variants[0].sku + '</p>');

            $('.rebuy-upsell-products .rebuy-product-media').append('<div class="rebuy-thumbs"></div>');
            upsellProduct.images.forEach(function (item, index) {
              var addShow = '';
              if (index == 1) {
                addShow = 'show';
              }
              // $('.rebuy-upsell-products .rebuy-product-media .rebuy-thumbs').append('<div class="rebuy-thumb mx-2 '+addShow+'"><img src="'+item.src+'" alt="'+item.alt+'" class=""></div>');
            });

            var upSellImgHtml = '';
            upSellImgHtml += '<div class="container1">';

            upSellImgHtml += '<div class="highlight-main">';

            upsellProduct.images.forEach(function (item, index) {
              var mainImg = item.src;
              mainImg = mainImg.replace('.jpg', '_200x.jpg').replace('.png', '_200x.png');
              upSellImgHtml += '<div class="carousel-cell">';
              upSellImgHtml += '<img src="' + mainImg + '" alt="' + item.alt + '">';
              upSellImgHtml += '</div>';
            });
            upSellImgHtml += '</div>';
            upSellImgHtml += '<div class="highlight-thumbs">';
            upsellProduct.images.forEach(function (item, index) {
              var thumbImg = item.src;
              thumbImg = thumbImg.replace('.jpg', '_80x.jpg').replace('.png', '_80x.png');
              upSellImgHtml += '<div class="carousel-cell">';
              upSellImgHtml += '<img src="' + thumbImg + '" alt="' + item.alt + '">';
              upSellImgHtml += '</div>';
            });
            upSellImgHtml += '</div>';

            upSellImgHtml += '</div>';

            if ($('.rebuy-upsell-products .rebuy-product-media .container1').length > 0) {
              $('.rebuy-upsell-products .rebuy-product-media .container1').remove();
            }
            $('.rebuy-upsell-products .rebuy-product-media').append(upSellImgHtml);

            setTimeout(function () {
              var flkty3 = new Flickity('.highlight-thumbs', {
                asNavFor: '.highlight-main',
                draggable: false,
                percentPosition: false,
                cellAlign: 'center',
                groupCells: '100%',
                prevNextButtons: false,
                pageDots: false,
                arrowShape: { x0: 10, x1: 60, y1: 45, x2: 60, y2: 35, x3: 20 }
              });

              var flkty4 = new Flickity('.highlight-main', {
                contain: true,
                wrapAround: false,
                draggable: false,
                setGallerySize: true,
                prevNextButtons: false,
                fullscreen: true,
                lazyLoad: true,
                pageDots: false
              });
            }, 500);

            if ($('.rebuy-upsell-products .rebuy-product-desc').length > 0) {
              $('.rebuy-upsell-products .rebuy-product-desc').remove();
            }
            if (app.product.metafields.upsell_desc && app.product.metafields.upsell_desc != '') {
              $('.rebuy-upsell-products .rebuy-product-price').after('<div class="rebuy-product-desc">' + app.product.metafields.upsell_desc + '</div>');
            }

            setTimeout(function () {
              window.dispatchEvent(new Event('resize'));
            }, 700);
          }

          if (event.detail.widget.element._prevClass == 'rebuy-cross-sell-products') {
            var crossSellProducts = event.detail.widget.data.products;
            crossSellProducts.forEach(function (item, index) {
              if ($('.rebuy-cross-sell-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-vendor').length > 0) {
                $('.rebuy-cross-sell-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-vendor').remove();
              }
              $('.rebuy-cross-sell-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info').prepend('<p class="rebuy-vendor">' + item.vendor + '</p>');
            });
          }

          $('.' + event.detail.widget.element._prevClass).find('.click-rebuy').click(function (ev) {
            ev.preventDefault();

            var $thishtml = $(ev.currentTarget).siblings('button.rebuy-button').html();

            var $thisClickVar = $(ev.target);
            var curVarId = $(ev.target).parents('.rebuy-product-block').find('.rebuy-select').val();

            $(ev.currentTarget).siblings('button.rebuy-button').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

            if (event.detail.widget.element._prevClass == 'rebuy-upsell-products') {
              // $(ev.currentTarget).parents('body').find('#rebuy-cart .rebuy-cart__flyout-item:eq(0) button.rebuy-cart__flyout-item-remove').trigger('click');                      
              $(ev.currentTarget).parents('body').find('.cart-drawer [data-cart-item]:eq(0) a.icon-close_kc').trigger('click');
              $(ev.currentTarget).parents('body').find('.cart-drawer [data-cart-item]:eq(0) a.icon-close_kc')[0].click();
            }

            var addCrtItem = openWidgetData.find(function (item) {
              return parseInt(item.selected_variant_id) === parseInt(curVarId);
            });

            var tempArray1 = addCrtItem;
            var array1 = [];

            $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions button, span.click-rebuy').wrapAll('<form method="post" action="/cart/add" accept-charset="UTF-8" data-product-form="" id="product_form_' + addCrtItem.id + '" enctype="multipart/form-data" data-product-id="' + addCrtItem.id + '" data-productid="' + addCrtItem.id + '" data-price="' + app._formatMoney(addCrtItem.selected_variant.price) + '" class="restock-form position-relative rebuy-form" data-hawkid="' + addCrtItem.selected_variant_id + '">');

            if (addCrtItem.product_type == 'Hornos') {
              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<div data-install="product_installation_horno-elite-touch-instalacion" class="has_installation"><input type="hidden" name="installation" value="yes"></div>');
            }

            $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[weight]" value="' + addCrtItem.selected_variant.weight + '">');

            $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[tags]" value="' + addCrtItem.tags.replace(/, /g, ',') + '">');

            $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[sku]" value="' + addCrtItem.selected_variant.sku + '">');

            $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[inventory]" value="' + addCrtItem.selected_variant.inventory_quantity + '">');

            if (event.detail.widget.element._prevClass == 'rebuy-cross-sell-products') {
              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_attribution]" value="Rebuy cross-sell">');
              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_widget_id]" value="' + event.detail.widget.id + '">');
            }
            if (event.detail.widget.element._prevClass == 'rebuy-upsell-products') {
              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_attribution]" value="Rebuy upsell">');
              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_widget_id]" value="' + event.detail.widget.id + '">');
            }

            $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_source]" value="Rebuy">');

            tempArray1.properties = { 'tags': addCrtItem.tags.replace(/, /g, ','), 'sku': addCrtItem.selected_variant.sku, 'inventory': addCrtItem.selected_variant.inventory_quantity, 'weight': parseInt(addCrtItem.selected_variant.weight) };
            tempArray1.variant_id = addCrtItem.selected_variant_id;

            for (var subitem in tempArray1) {
              if (subitem != 'id' && subitem != 'properties' && subitem != 'variant_id') {
                delete tempArray1[subitem];
              }
            }

            var contains = { items: array1 };

            if (app.selectedRegion != null) {
              var valReg = app.selectedRegion;
            } else {
              var valReg = $('[data-regions]').val();
            }

            if (app.selectedComuna != null) {
              var valCom = app.selectedComuna;
            } else {
              var valCom = $('[data-district]').val();
            }

            if (valReg && valReg != '' && valReg != null && valReg != undefined && valCom && valCom != '' && valCom != null && valCom != undefined) {
              var data = {
                location_id: 'null',
                shipping_type: 'delivery',
                region: valReg,
                district: valCom,
                cart: JSON.stringify(contains),
                date_count: 1,
                change_shipping_type: 0
              };

              var _ajax_url2 = void 0;
              if (app.freeShippingEnabled) {
                _ajax_url2 = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
              } else {
                _ajax_url2 = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
              }

              $.ajax({
                type: 'POST',
                url: _ajax_url2,
                dataType: 'json',
                data: data,
                success: function success(data) {
                  data.forEach(function (item, index) {
                    $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_type]" value="' + item.type + '">');
                    $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_price]" value="' + item.shipping_price + '">');
                    if (item.type == 'preorder') {
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="' + item.start_date + '">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[range_date]" value="' + item.start_date + ' - ' + item.end_date + '">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="' + item.fulfillment_date + '">');
                    } else if (item.type == 'marketplace') {
                      // $('[data-del_seller]').text(item.text).removeClass('d-none');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="' + item.delivery_date + '">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[range_date]" value="' + item.start_date + ' - ' + item.end_date + '">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="' + item.fulfillment_date + '">');
                    } else {

                      if (item.type == 'pickup') {
                        var ship_pick_dates = item.pickup_dates;
                      } else {
                        var ship_pick_dates = item.shipping_dates;
                      }

                      var dileveryDate = [];
                      var getMonth = '';
                      var firstDate = '';
                      var firstFullfillDate = '';

                      var count = 0;
                      $.each(ship_pick_dates, function (shipping_date) {
                        if (count == 0) {
                          getMonth = shipping_date;
                          firstDate = shipping_date;
                          firstFullfillDate = ship_pick_dates[shipping_date].fulfilment_date;
                        }
                        if (count < 10) {
                          dileveryDate.push(shipping_date);
                        }
                        count = count + 1;
                      });
                      getMonth = getMonth.split('-')[1];
                      if (item.type == 'pickup') {} else {
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="' + firstDate + '">');
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="' + firstFullfillDate + '">');
                      }
                    }

                    $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_store]" value="">');
                    $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_storeid]" value="">');
                    $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[pick_available]" value="false">');
                    $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[pickup_date]" value="">');
                  });

                  setTimeout(function () {
                    app._addToCart(curVarId, ev);

                    app.isCartDrawerOpen = true;
                    app.isOverlayVisible = true;

                    $(ev.currentTarget).siblings('button.rebuy-button').html($thishtml);

                    $(ev.currentTarget).parents('.rebuy-widget-container').find('.rebuy-modal-close').click(function (event) {
                      $('.widget-display-popup').removeClass('is-visible').addClass('is-hidden');
                    });
                  }, 2000);

                  setTimeout(function () {
                    $('.widget-display-popup').removeClass('is-visible').addClass('is-hidden');
                  }, 3000);
                }
              });
            } else {
              $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_type]" value="delivery">');
              $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_price]" value="">');
              $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="">');
              $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="">');
              $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_store]" value="">');
              $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_storeid]" value="">');
              $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[pick_available]" value="false">');
              $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[pickup_date]" value="">');
              setTimeout(function () {
                app._addToCart(curVarId, ev);
                $(ev.currentTarget).siblings('button.rebuy-button').html('<span>AGREGAR AL CARRO</span>');
                $('.widget-display-popup').removeClass('is-visible').addClass('is-hidden');

                $(ev.currentTarget).parents('.rebuy-widget-container').find('.rebuy-modal-close').click(function (event) {
                  $('.widget-display-popup').removeClass('is-visible').addClass('is-hidden');
                });
              }, 1000);
            }
          });
        });

        document.addEventListener("rebuy:cart.change", function () {
          if ($('.rebuy-just-added').length > 0) {
            if (Rebuy.Cart.cart.items[0].handle != 'grill-assembly-service') {
              $('.rebuy-just-added [data-qty-input]').val(Rebuy.Cart.cart.items[0].quantity);
            } else {
              $('.rebuy-just-added [data-qty-input]').val(Rebuy.Cart.cart.items[1].quantity);
            }
          }
        });
      }

      if (app.currentTemplate != 'cart') {
        document.addEventListener('rebuy:smartcart.show', function (event) {
          setTimeout(function () {
            var recomWidget = Rebuy.widgets.find(function (item) {
              return parseInt(item.id) == "38170";
            });
            if (recomWidget.data.products) {
              if (recomWidget.data.products.length == 0) {
                $('.rebuy-cart__flyout-recommendations').hide();
              } else {
                $('.rebuy-cart__flyout-recommendations').show();
                recomWidget.data.products.forEach(function (item, index) {
                  $('.rebuy-cart__flyout-recommendations .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-actions .click-rebuy').remove();
                  $('.rebuy-cart__flyout-recommendations .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-actions .rebuy-button').before('<span class="button-overlay click-rebuy d-block"></span>');
                });
              }
            }

            $('.cart-icon span').text(Rebuy.SmartCart.cart.item_count);
            $('.cart-icon p').text(app._formatMoney(Rebuy.SmartCart.cart.total_price));

            var openWidgetDataSC = recomWidget.data.products;
            $('.rebuy-cart .click-rebuy').click(function (ev) {
              ev.preventDefault();
              var $thishtml = $(ev.currentTarget).siblings('button.rebuy-button').html();
              var $thisClickVar = $(ev.target);
              var curVarIdHref = $(ev.target).parents('.rebuy-product-block').find('.rebuy-product-info a').attr('href');
              var curVarId = app._getParameterfromString(curVarIdHref, 'variant');
              $(ev.currentTarget).siblings('button.rebuy-button').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');

              var addCrtItem = openWidgetDataSC.find(function (item) {
                return parseInt(item.selected_variant_id) === parseInt(curVarId) || parseInt(item.variant_id) === parseInt(curVarId);
              });
              var tempArray1 = addCrtItem;
              var array1 = [];

              if (addCrtItem.selected_variant_id != undefined) {
                $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions button, span.click-rebuy').wrapAll('<form method="post" action="/cart/add" accept-charset="UTF-8" data-product-form="" id="product_form_' + addCrtItem.id + '" enctype="multipart/form-data" data-product-id="' + addCrtItem.id + '" data-productid="' + addCrtItem.id + '" data-price="' + app._formatMoney(addCrtItem.selected_variant.price) + '" class="restock-form position-relative rebuy-form" data-hawkid="' + addCrtItem.selected_variant_id + '">');
              } else {
                $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions button, span.click-rebuy').wrapAll('<form method="post" action="/cart/add" accept-charset="UTF-8" data-product-form="" id="product_form_' + addCrtItem.id + '" enctype="multipart/form-data" data-product-id="' + addCrtItem.id + '" data-productid="' + addCrtItem.id + '" class="restock-form position-relative rebuy-form" data-hawkid="' + addCrtItem.variant_id + '">');
              }

              if (addCrtItem.product_type == 'Hornos') {
                $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<div data-install="product_installation_horno-elite-touch-instalacion" class="has_installation"><input type="hidden" name="installation" value="yes"></div>');
              }

              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[weight]" value="' + addCrtItem.selected_variant.weight + '">');
              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[tags]" value="' + addCrtItem.tags.replace(/, /g, ',') + '">');
              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[sku]" value="' + addCrtItem.selected_variant.sku + '">');
              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[inventory]" value="' + addCrtItem.selected_variant.inventory_quantity + '">');
              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_attribution]" value="Smart Cart">');
              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_widget_id]" value="38170">');

              $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[_source]" value="Rebuy">');
              tempArray1.properties = { 'tags': addCrtItem.tags.replace(/, /g, ','), 'sku': addCrtItem.selected_variant.sku, 'inventory': addCrtItem.selected_variant.inventory_quantity, 'weight': parseInt(addCrtItem.selected_variant.weight) };
              tempArray1.variant_id = addCrtItem.selected_variant_id;
              for (var subitem in tempArray1) {
                if (subitem != 'id' && subitem != 'properties' && subitem != 'variant_id') {
                  delete tempArray1[subitem];
                }
              }

              array1.push(tempArray1);
              var contains = { items: array1 };

              if (app.selectedRegion != null) {
                var valReg = app.selectedRegion;
              } else {
                var valReg = $('[data-regions]').val();
              }
              if (app.selectedComuna != null) {
                var valCom = app.selectedComuna;
              } else {
                var valCom = $('[data-district]').val();
              }

              if (valReg && valReg != '' && valReg != null && valReg != undefined && valCom && valCom != '' && valCom != null && valCom != undefined) {
                var data = {
                  location_id: 'null',
                  shipping_type: 'delivery',
                  region: valReg,
                  district: valCom,
                  cart: JSON.stringify(contains),
                  date_count: 1,
                  change_shipping_type: 0
                };

                var _ajax_url3 = void 0;
                if (app.freeShippingEnabled) {
                  _ajax_url3 = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
                } else {
                  _ajax_url3 = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
                }

                $.ajax({
                  type: 'POST',
                  url: _ajax_url3,
                  dataType: 'json',
                  data: data,
                  success: function success(data) {
                    data.forEach(function (item, index) {
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_type]" value="' + item.type + '">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_price]" value="' + item.shipping_price + '">');
                      if (item.type == 'preorder') {
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="' + item.start_date + '">');
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[range_date]" value="' + item.start_date + ' - ' + item.end_date + '">');
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="' + item.fulfillment_date + '">');
                      } else if (item.type == 'marketplace') {
                        // $('[data-del_seller]').text(item.text).removeClass('d-none');
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="' + item.delivery_date + '">');
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[range_date]" value="' + item.start_date + ' - ' + item.end_date + '">');
                        $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="' + item.fulfillment_date + '">');
                      } else {

                        if (item.type == 'pickup') {
                          var ship_pick_dates = item.pickup_dates;
                        } else {
                          var ship_pick_dates = item.shipping_dates;
                        }

                        var dileveryDate = [];
                        var getMonth = '';
                        var firstDate = '';
                        var firstFullfillDate = '';

                        var count = 0;
                        $.each(ship_pick_dates, function (shipping_date) {
                          if (count == 0) {
                            getMonth = shipping_date;
                            firstDate = shipping_date;
                            firstFullfillDate = ship_pick_dates[shipping_date].fulfilment_date;
                          }
                          if (count < 10) {
                            dileveryDate.push(shipping_date);
                          }
                          count = count + 1;
                        });
                        getMonth = getMonth.split('-')[1];
                        if (item.type == 'pickup') {} else {
                          $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="' + firstDate + '">');
                          $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="' + firstFullfillDate + '">');
                        }
                      }

                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_store]" value="">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_storeid]" value="">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[pick_available]" value="false">');
                      $thisClickVar.parents('.rebuy-product-block').find('.rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[pickup_date]" value="">');
                    });

                    setTimeout(function () {
                      app._addToCart(curVarId, ev);
                      $(ev.currentTarget).siblings('button.rebuy-button').html($thishtml);
                      $(ev.currentTarget).parents('.rebuy-widget-container').find('.rebuy-modal-close').click(function (event) {
                        $('.widget-display-popup').removeClass('is-visible').addClass('is-hidden');
                      });
                    }, 2000);
                  }
                });
              } else {
                $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_type]" value="delivery">');
                $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_price]" value="">');
                $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[delivery_date]" value="">');
                $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[fulfillment_date]" value="">');
                $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_store]" value="">');
                $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[shipping_storeid]" value="">');
                $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[pick_available]" value="false">');
                $('.rebuy-product-block .rebuy-product-actions .rebuy-form').append('<input type="hidden" name="properties[pickup_date]" value="">');
                setTimeout(function () {
                  app._addToCart(curVarId, ev);
                  $(ev.currentTarget).siblings('button.rebuy-button').html('<span>AGREGAR AL CARRO</span>');
                  $(ev.currentTarget).parents('.rebuy-widget-container').find('.rebuy-modal-close').click(function (event) {
                    $('.widget-display-popup').removeClass('is-visible').addClass('is-hidden');
                  });
                }, 1000);
              }
            });
          }, 1000);
        });
      }

      if (app.currentTemplate == 'cart') {
        if ($('[data-shipping-check]').attr('data-change_comuna') == 'true' || $('[data-shipping-check]').attr('data-change_comuna') == true) {

          // let thisVarid = $this.attr('data-variantpop-id');
          var change_shipping_type = $('[data-shipping-check]').attr('data-change_shipping_type');
          var checkInstPrd = [];
          app.cart.items.forEach(function (item, index) {
            if (item.product_type == 'Warranty' || item.product_type == 'Installation') {
              $.ajax({
                type: "GET",
                async: false,
                url: '/products/' + item.handle + '?view=json',
                dataType: "json",
                success: function success(data) {
                  if (data.product.tags == '') {
                    item.properties.tags = '';
                  } else {
                    item.properties.tags = data.product.tags.toString();
                  }
                }
              });
            }
            if (item.product_type == 'Installation') {
              checkInstPrd.push(item.id);
            }
          });

          // let thisItem = app.cart.items.find((item) => parseInt(item.variant_id) === parseInt(thisVarid));

          var tempArray = app.cart.items;
          tempArray.forEach(function (item, index) {

            for (var subitem in item) {
              if (subitem != 'id' && subitem != 'properties' && subitem != 'quantity' && subitem != 'variant_id' && subitem != 'vendor' && subitem != 'requires_shipping' && subitem != 'product_type') {
                delete item[subitem];
              }
            }
          });

          array = tempArray;

          if ($this.attr('data-shipp_type') != '') {
            var shipping_type = $this.attr('data-shipp_type');
          }

          var contains = { items: array };

          var location_id = 'null';
          var valReg = $('.show-autocon [data-regions]').val();
          var valCom = $('.show-autocon [data-district]').val();

          var address1 = $('.show-autocon [name="ship-addr"]').val();
          var address2 = $('.show-autocon [name="addrr2"]').val();

          if (valReg != null && valReg != '') {
            document.cookie = 'selectedRegion=' + valReg + ';path=/' + ';';
            // app.selectedRegion = valReg;
          }
          if (valCom != null && valCom != '') {
            document.cookie = 'selectedComuna=' + valCom + ';path=/' + ';';
            // app.selectedComuna = valCom;

            document.cookie = 'selCommonC=' + valCom + ';path=/' + ';';
            document.cookie = 'selCommonR=' + valReg + ';path=/' + ';';

            $.post('/cart.js', {
              attributes: {
                'Region': valReg,
                'Comuna': valCom
              }
            }).done(function () {});
          }

          document.cookie = 'selectedaddress1=' + address1 + ';path=/' + ';';
          document.cookie = 'selectedaddress2=' + address2 + ';path=/' + ';';

          if (navigator.userAgent.toLowerCase().indexOf('safari') > -1) {
            localStorage.setItem('selectedaddress1', address1);
          }

          if ($('.show-autocon #checkout_verify_address').prop('checked') == true && $('.show-autocon .checkbox-wrapper').is(':visible')) {
            document.cookie = 'selectedAddVerified=1;path=/' + ';';
          } else {
            document.cookie = 'selectedAddVerified=0;path=/' + ';';
          }

          if (valReg && valReg != '' && valReg != null && valReg != undefined && valCom && valCom != '' && valCom != null && valCom != undefined) {
            var dataConfigN = {
              location_id: location_id,
              shipping_type: shipping_type,
              region: valReg,
              district: valCom,
              cart: JSON.stringify(contains),
              date_count: 1,
              change_shipping_type: change_shipping_type,
              change_comuna: 1
            };

            if (app.freeShippingEnabled) {
              var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
            } else {
              var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
            }

            $.ajax({
              type: 'POST',
              url: ajax_url,
              dataType: 'json',
              data: dataConfigN,
              beforeSend: function beforeSend() {
                $('[data-shipping-check]').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
              },
              success: function success(data) {
                if (data.errors) {
                  setTimeout(function () {
                    location.reload();
                  }, 2500);
                  return false;
                }
                var setTimeFinal = 0;
                var check24hdel = 0;

                data.forEach(function (item, index) {
                  var shipping_type = item.type;
                  var tempProperties = {};
                  var thisVarid = item.id;
                  var thisItem = app.cart.items.find(function (item) {
                    return parseInt(item.variant_id) === parseInt(thisVarid);
                  });

                  if (item.allow_24H_delivery == true) {
                    check24hdel = 1;
                  }

                  var line = 0;
                  app.cart.items.forEach(function (item, index) {
                    if (parseInt(item.id) == parseInt(thisVarid)) {
                      line = index;
                    }
                  });

                  var lineitem = line + 1;
                  var dataConfig2 = {
                    quantity: thisItem.quantity,
                    line: lineitem,
                    properties: ''
                  };

                  tempProperties = thisItem.properties;

                  tempProperties['shipping_type'] = item.type;
                  if (shipping_type == 'preorder') {
                    tempProperties['shipping_price'] = item.shipping_price;
                    tempProperties['delivery_date'] = item.start_date;
                    tempProperties['range_date'] = item.start_date + ' - ' + item.end_date;
                    tempProperties['fulfillment_date'] = item.fulfillment_date;
                  } else if (shipping_type == 'marketplace') {
                    tempProperties['shipping_price'] = item.shipping_price;
                    tempProperties['delivery_date'] = item.delivery_date;
                    tempProperties['range_date'] = item.start_date + ' - ' + item.end_date;
                    tempProperties['fulfillment_date'] = item.fulfillment_date;
                  } else {
                    if (shipping_type == 'pickup') {
                      var ship_pick_dates = item.pickup_dates;
                      var selShipdateArray = $.map(ship_pick_dates, function (element, index) {
                        return index;
                      });
                      var selShipdate = selShipdateArray.toString();
                    } else {
                      var ship_pick_dates = item.shipping_dates;
                      var selShipdateArray = $.map(ship_pick_dates, function (element, index) {
                        return index;
                      });
                      var selShipdate = selShipdateArray.toString();
                      var selFullfilldate = ship_pick_dates[selShipdate].fulfilment_date;
                    }

                    tempProperties['delivery_date'] = selShipdate;
                    tempProperties['pickup_date'] = '';

                    if (shipping_type == 'pickup') {
                      tempProperties['shipping_price'] = '';
                      tempProperties['pick_available'] = item.pick_available;
                    } else if (shipping_type == 'preorder') {} else if (shipping_type == 'marketplace') {} else {
                      tempProperties['shipping_price'] = item.shipping_price;
                      tempProperties['fulfillment_date'] = selFullfilldate;

                      tempProperties['pick_available'] = item.pick_available;

                      tempProperties['shipping_store'] = '';
                      tempProperties['shipping_storeid'] = '';
                    }
                  }

                  dataConfig2.properties = tempProperties;

                  var setTime = index * 500;
                  setTimeFinal = index * 500 + 300;
                  setTimeout(function () {
                    jQuery.ajax({
                      url: '/cart/change.js',
                      dataType: 'json',
                      data: dataConfig2
                    }).done(function (rep) {});
                  }, setTime);
                });

                if (check24hdel != 0) {
                  localStorage.setItem('allow24hDelBlk', 'true');
                } else {
                  if (data.length > 1) {
                    localStorage.removeItem('allow24hDelBlk');
                  }
                }

                setTimeout(function () {
                  app.selectedRegion = valReg;
                  app.selectedComuna = valCom;

                  if (valReg != 'Región Metropolitana' && checkInstPrd.length > 0) {
                    $('#modalWarningInsPrd').modal('show');
                    if ($('.modal-backdrop').length == 2) {
                      $('.modal-backdrop').addClass('must-show');
                    }
                    $('#app').addClass('show-ins-overlay');
                    var $prodQTY = [];
                    $(app.cart.items).each(function (index, item) {
                      var varId = item.id;
                      var varQty = item.quantity;
                      if ($.inArray(varId, checkInstPrd) >= 0) {
                        varQty = 0;
                      }
                      $prodQTY.push(varQty);
                    });

                    axios.post('/cart/update.js', {
                      updates: $prodQTY
                    }).then(function (response) {
                      app.isLoading = false;
                      app._getCartData();
                    });
                  } else {
                    app._getCartData();
                  }
                }, setTimeFinal);
                setTimeout(function () {
                  $('.msg-reg-com').addClass('d-none');
                  $('#modalForShipping').modal('hide');
                  $('[data-shipping-check]').addClass('button-hidden');
                  $('[data-shipping-check]').html('Seleccionar');
                  $('[data-shipping-check]').removeAttr('data-change_comuna');
                  $('[data-shipping-check]').removeAttr('data-change_shipping_type');
                  app.selectedRegion = valReg;
                  app.selectedComuna = valCom;
                }, setTimeFinal + 300);
              },
              error: function error(err) {
                if (err.responseJSON.errors) {
                  var title = 'Mensaje de error';
                  var body = 'Complete todos los datos';
                  app.$snotify.error(body, title, {
                    timeout: 3000,
                    showProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    titleMaxLength: 80,
                    icon: 'https://cdn.shopify.com/s/files/1/0111/6448/3647/files/danger.png?v=1620208423',
                    buttons: [{
                      text: 'Cerrar',
                      bold: true,
                      closeOnClick: true
                    }]
                  });
                  setTimeout(function () {
                    location.reload();
                  }, 2500);
                  return false;
                }
              }
            });
          }
        }
      }
    },
    _ALAcheck: function _ALAcheck() {
      // eslint-disable-next-line no-var
      var isALARendered = setInterval(function () {
        if ($('.selected-communa').length > 0) {
          var a = $('.selected-communa')[0];
          var b = a.innerHTML;
          if (b.indexOf('selecciona tu comuna') === -1) {
            $('.selected-communa')[0].click();
            // eslint-disable-next-line radix
            document.cookie = 'selFromCheckout=' + parseInt(0) + ';path=/' + ';';
            clearInterval(isALARendered);
          }
        }
      }, 200);
    },
    _mergeObjs: function _mergeObjs(def, obj) {
      if (typeof obj === 'undefined') {
        return def;
      } else if (typeof def === 'undefined') {
        return obj;
      }
      for (var i in obj) {
        if (obj[i] != null && obj[i].constructor === Object) {
          def[i] = app._mergeObjs(def[i], obj[i]);
        } else {
          def[i] = obj[i];
        }
      }
      return def;
    },
    _getCartDefault: function _getCartDefault() {
      return axios.get('/cart.js', axiosConfig);
    },
    _getCartExtra: function _getCartExtra() {
      return axios.get('/cart?view=extra.json', axiosConfig);
    },


    /**
     * Get the cart data json object
     */
    _getCartData: function _getCartData() {
      // we make our own enhanced version of the cart object.
      // we are merging Shopify's default cart object
      // and some more additional data like product options and metafields
      // eslint-disable-next-line promise/catch-or-return
      axios.all([app._getCartDefault(), app._getCartExtra()]).then(axios.spread(function (basic, extra) {
        // Both requests are now complete
        var basicCartData = basic.data;
        var mergedItems = app._mergeObjs(basic.data.items, extra.data.items);
        basicCartData.items = mergedItems;
        app.cart = basicCartData;
        var selected_warranty_price = 0;
        var selected_installtion_price = 0;
        var selected_grillassembly_price = 0;
        var delveryDates = [];
        var delveryDatesTF = [];
        var preorderDates = [];
        var delverySellers = [];
        var delverySellersVend = [];
        var pickStores = [];

        var paramsDel = [];
        var paramsDelnew = [];

        var paramsDelTF = [];

        var paramsPre = [];

        var paramsDelSel = [];
        var paramsDelSelnew = [];
        var paramVendor = [];

        var paramsPick = [];
        var paramsPicknew = [];

        // let marketplaceDates = [];
        var similarDel = [];

        var delPriceCount = 0;
        var delSelPriceCount = 0;
        var preorderPriceCount = 0;

        basicCartData.items.forEach(function (item, index) {

          var counting = app.cart.item_count;

          if (!item.properties) {
            item.properties = [];
          }

          // ========== warranty product functionality start

          if (app.cart.items[index].product_type == 'Warranty') {
            counting -= app.cart.items[index].quantity;
          }
          app.cart.item_count = counting;
          var mainRandNo = '';
          var subRandNo = void 0;
          var mainQty = void 0;
          setTimeout(function () {
            if (item.product_type != 'Warranty') {
              if (item.properties.random_no != null) {
                mainRandNo = item.properties.random_no;
                mainQty = item.quantity;

                var _loop = function _loop(i) {
                  var dupRand = mainRandNo + "-" + i;
                  $(app.cart.items).each(function (index, item) {
                    if (item.product_type == 'Warranty') {
                      var subVarId = item.variant_id;
                      subRandNo = item.properties.random_no;
                      if (subRandNo == dupRand) {
                        subVarId = "var-" + subVarId;

                        var prop_checked = $("[data-subrandom-no=" + subRandNo + "]").find("." + subVarId).prop('checked', true);

                        if ($("." + subVarId).is(':checked')) {
                          var warrText = $("." + subVarId).data('warr-text');
                          var warrPrice = $("." + subVarId).data('warr-price');
                          warrPrice = "" + warrPrice;
                          var price = item.line_price;
                          selected_warranty_price += price;

                          var formatedPrice = app._formatMoney(price);
                          $("." + subVarId).parents('[data-cart-item]').find("[data-subrandom-no=" + subRandNo + "]").find('.card').addClass('haswarranty').attr('data-waranty-qty', item.quantity);
                          $("." + subVarId).parents('[data-cart-item]').find("[data-subrandom-no=" + subRandNo + "]").find('[data-select-text]').html(warrText);
                          $("." + subVarId).parents("[data-subrandom-no=" + subRandNo + "]").parents('[data-cart-item]').find('[data-select-price]').html(formatedPrice);
                          $("." + subVarId).parents("[data-subrandom-no=" + subRandNo + "]").parents('[data-cart-item]').find('[data-select-price]').parent('span').removeClass('d-none');
                          $("." + subVarId).parents('[data-cart-item]').find("[data-subrandom-no=" + subRandNo + "]").find('.after-select').addClass('d-flex').removeClass('d-none');
                          $("." + subVarId).parents('[data-cart-item]').find("[data-subrandom-no=" + subRandNo + "]").find('.before-select').addClass('d-none').removeClass('d-flex');
                          prop_checked.siblings('[data-update-warr]').addClass('d-block').removeClass('d-none');
                        }
                      }
                    }
                  });
                };

                for (var i = 1; i <= mainQty; i++) {
                  _loop(i);
                }

                setTimeout(function () {
                  var wr_price = 0;
                  $('[data-cart-item][data-variant-id="' + item.id + '"]').find('.extended-warranty [data-subrandom-no]').each(function () {
                    if ($(this).find('.after-select').is(':visible')) {
                      var w_val = $(this).find('.item_warranty_variants input:checked').attr('data-warr-aprice');
                      wr_price = parseInt(wr_price) + parseInt(w_val);
                    }
                  });
                  if (wr_price > 0) {
                    var formatedWrPrice = app._formatMoney(wr_price);
                    $('[data-cart-item][data-variant-id="' + item.id + '"] [data-select-wrr-price]').html(formatedWrPrice);
                    $('[data-cart-item][data-variant-id="' + item.id + '"] [data-select-wrr-price]').parent('span').removeClass('d-none');
                  }
                }, 500);
              }
            }
          }, 400);
          // ========== warranty product functionality end

          // ========== installation product functionality start

          if (app.cart.items[index].product_type == 'Installation' || app.cart.items[index].product_type == 'Grill assembly') {
            counting -= app.cart.items[index].quantity;
          }
          app.cart.item_count = counting;
          var mainRandmNo = '';
          var subRandmNo = void 0;
          var main_Qty = void 0;
          setTimeout(function () {
            if (item.product_type != 'Installation' && item.product_type != 'Grill assembly') {
              if (item.properties.random_no != null) {
                (function () {
                  mainRandmNo = item.properties.random_no;
                  main_Qty = item.quantity;
                  var subVarId = item.variant_id;

                  var _loop2 = function _loop2(i) {
                    var dupRand = mainRandmNo + "-" + i;
                    $(app.cart.items).each(function (index, item) {
                      if (item.product_type == 'Installation' || item.product_type == 'Grill assembly') {
                        subRandmNo = item.properties.random_no;
                        if (subRandmNo == dupRand) {
                          var price = item.line_price;
                          if (item.product_type == 'Installation') {
                            selected_installtion_price += price;
                          } else if (item.product_type == 'Grill assembly') {
                            selected_grillassembly_price += price;
                          }

                          subVarId = "var-" + subVarId;
                          $("[data-subrandom-no=" + subRandmNo + "].installation-before").addClass('d-none');
                          $("[data-subrandom-no=" + subRandmNo + "].installation-after").removeClass('d-none');
                        }
                      }
                    });
                  };

                  for (var i = 1; i <= main_Qty; i++) {
                    _loop2(i);
                  }
                })();
              }
            }
          }, 400);
          // ========== installation product functionality end

          if (item.product_type != 'Warranty' && item.product_type != 'Installation' && item.product_type != 'Grill assembly') {
            if (item.properties.shipping_type && item.properties.shipping_type != '') {
              app.cart.items[index].shipping_type = item.properties.shipping_type;
            }
            if (item.properties.shipping_type == 'delivery') {
              var checkTF = item.properties.tags;
              if (checkTF.indexOf('delivery_24h') > -1 && app._setNextDay('numeric') == item.properties.delivery_date && localStorage.getItem('allow24hDelBlk') && localStorage.getItem('allow24hDelBlk') == 'true') {
                paramsDelTF.push(item.properties.delivery_date);
                app.cart.items[index].chck2del24h = 'yes';
              } else {
                paramsDel.push(item.properties.delivery_date);
                paramsDelnew[item.id] = item.properties.delivery_date;
                app.cart.items[index].chck2del24h = 'no';
              }

              delPriceCount = delPriceCount + 1;
              if (delPriceCount == 1) {
                app.cart.chck2DeliveryShipPrice = item.properties.shipping_price;
              }
            }
            if (item.properties.shipping_type == 'preorder') {
              paramsPre.push(item.properties.range_date);

              preorderPriceCount = preorderPriceCount + 1;
              if (preorderPriceCount == 1) {
                app.cart.chck2PreorderShipPrice = item.properties.shipping_price;
              }
            }
            if (item.properties.shipping_type == 'marketplace') {
              var marketplaceSaller = null;

              var itemTags = [];
              itemTags = item.properties.tags.split(',');
              itemTags.forEach(function (tag) {
                if (tag.match('seller_')) {
                  marketplaceSaller = tag.split('seller_');
                  app.cart.items[index].marketplaceSaller = marketplaceSaller[1];

                  paramVendor.push(marketplaceSaller[1]);
                  paramsDelSel.push(marketplaceSaller[1] + ': ' + item.properties.range_date);
                }
              });

              // marketplaceDates.push(item.properties.range_date);

              paramsDelSelnew[item.id] = item.properties.range_date;

              delSelPriceCount = delSelPriceCount + 1;
              if (delSelPriceCount == 1) {
                app.cart.chck2DelSelShipPrice = item.properties.shipping_price;
              }
            }
            if (item.properties.shipping_type == 'pickup') {
              paramsPick.push(item.properties.shipping_store);
              paramsPicknew[item.id] = item.properties.shipping_store;
            }
          }
        });

        //delivery
        var uniqueDel = paramsDel.filter(function (itm, i, paramsDel) {
          return i == paramsDel.indexOf(itm);
        });

        uniqueDel = uniqueDel.sort(function (a, b) {
          return new Date(a) - new Date(b);
        });

        delveryDates = uniqueDel;

        //delivery 24
        var uniqueDelTF = paramsDelTF.filter(function (itm, i, paramsDelTF) {
          return i == paramsDelTF.indexOf(itm);
        });
        uniqueDelTF = uniqueDelTF.sort(function (a, b) {
          return new Date(a) - new Date(b);
        });
        delveryDatesTF = uniqueDelTF;

        //preorder
        var uniquePre = paramsPre.filter(function (itm, i, paramsPre) {
          return i == paramsPre.indexOf(itm);
        });
        preorderDates = uniquePre;

        //delivery from seller
        var uniqueDelSel = paramsDelSel.filter(function (itm, i, paramsDelSel) {
          return i == paramsDelSel.indexOf(itm);
        });

        var uniqueDelSelVend = paramVendor.filter(function (itm, i, paramVendor) {
          return i == paramVendor.indexOf(itm);
        });
        delverySellersVend = uniqueDelSelVend;

        var sallernmArray = [];
        var param = {};
        uniqueDelSelVend.forEach(function (sellerkey, i) {
          var sallerdtArray = [];
          var sallerdtArray1 = [];
          uniqueDelSel.forEach(function (commomkey, i) {
            // var sellernm = commomkey.split(': ')[0];
            var sellerdt = commomkey.split(': ')[1].split(' - ')[1];
            // sallernmArray.push([sellernm,sellerdt]);
            if (commomkey.indexOf(sellerkey) > -1) {
              sallerdtArray.push(new Date(sellerdt));
              sallerdtArray1.push(sellerdt);
            }
          });
          var large_date = new Date(Math.max.apply(null, sallerdtArray));
          var dd = String(large_date.getDate()).padStart(2, '0');
          var mm = String(large_date.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = large_date.getFullYear();
          large_date = yyyy + '-' + mm + '-' + dd;

          // var largeDateConvert = moment(large_date);
          // largeDateConvert.locale('es');
          // let moment_large_date = largeDateConvert.format('YYYY') + '-' + largeDateConvert.format('MM') + '-' + largeDateConvert.format('DD');

          var moments = sallerdtArray1.map(function (d) {
            return moment(d);
          });
          var maxDate = moment.max(moments);
          var moment_large_date = maxDate.format('YYYY') + '-' + maxDate.format('MM') + '-' + maxDate.format('DD');
          param[sellerkey] = moment_large_date;
        });

        var take_val = [];
        for (var key in param) {
          uniqueDelSel.forEach(function (commomkey, i) {
            if (commomkey.indexOf(key) > -1 && commomkey.indexOf(' - ' + param[key]) > -1) {
              take_val.push(commomkey);
            }
          });
        }

        uniqueDelSel = uniqueDelSel.filter(function (item) {
          return take_val.includes(item);
        });

        delverySellers = uniqueDelSel;

        // pickup
        var uniquePick = paramsPick.filter(function (itm, i, paramsPick) {
          return i == paramsPick.indexOf(itm);
        });
        pickStores = uniquePick;

        setTimeout(function () {
          app.WarrantyTotalPrice = selected_warranty_price;
        }, 500);

        setTimeout(function () {
          app.InstallationTotalPrice = selected_installtion_price;
        }, 500);

        setTimeout(function () {
          app.GrillAssemblyTotalPrice = selected_grillassembly_price;
        }, 500);

        var valReg = app.selectedRegion;
        var valCom = app.selectedComuna;

        if (valReg != null && valCom != null) {
          setTimeout(function () {
            if ($('.main_ship').length > 0) {
              var blockMainArray = [];
              var dataCheck = 0;
              $('.main_ship').each(function (i) {
                var data = {};
                var main_ship = 0;
                var productAll = [];

                $(this).find('[data-cart-item]').each(function () {
                  var blockArray = {};
                  var allitem_tags = '';
                  var data_variant_id = $(this).attr('data-variant-id');
                  var data_product_id = $(this).attr('data-product-id');
                  var data_col_ids = $(this).attr('data-coll-id');
                  if (data_variant_id != '' && data_product_id != '' && data_col_ids != '') {
                    dataCheck = dataCheck + 1;
                  }

                  main_ship = main_ship + parseFloat($(this).attr('data-prd-weight'));
                  if ($(this).attr('data-tags') != '') {
                    allitem_tags = allitem_tags + ',' + $(this).attr('data-tags');
                  }
                  var tagArr = allitem_tags.split(',');
                  var uniquetagArr = tagArr.filter(function (itm, i, tagArr) {
                    return i == tagArr.indexOf(itm);
                  });
                  var final_tags = uniquetagArr.join(',').substr(1);
                  blockArray.collection_ids = data_col_ids;
                  blockArray.product_id = data_product_id;
                  blockArray.variant_id = data_variant_id;
                  blockArray.weight = main_ship;
                  blockArray.tags = final_tags;
                  productAll.push(blockArray);
                });
                data.block_id = i;
                data.products = productAll;
                blockMainArray.push(data);
              });
              var shop_data = blockMainArray;
              var dataNew = {
                region: valReg,
                district: valCom,
                blocks: JSON.stringify(shop_data),
                subtotal: app.cart.total_price
                // shop: app.shop.domain1,
              };

              if (app.freeShippingEnabled) {
                var ajax_url_price = 'https://app.kitchencenter.cl/api/calendar/shipping_price_free';
              } else {
                var ajax_url_price = 'https://app.kitchencenter.cl/api/calendar/v2/shipping_price';
              }

              var tot_ship_val = 0;
              if (dataCheck == $('[data-cart-form] [data-cart-item]').length) {
                $.ajax({
                  type: 'POST',
                  url: ajax_url_price,
                  dataType: 'json',
                  data: dataNew,
                  success: function success(data) {
                    data.forEach(function (item) {
                      $(".main_ship:eq(" + item.block_id + ")").find('.ship_price span').text(item.shipping_price);
                      tot_ship_val = parseFloat(tot_ship_val) + parseFloat(item.shipping_price);
                    });

                    if (window.theme.offerFreeShipEnabled && window.theme.offerFreeShipAmount != '' && parseFloat(window.theme.offerFreeShipAmount) <= parseFloat(app.cart.total_price / 100000)) {
                      // app.cart.chck2TotalShipPrice = tot_ship_val.toFixed(2);
                      $('.total_shipping_price h6 span').text(app._formatMoney(0));
                      $('.total_shipping_price').removeClass('d-none');
                      // eslint-disable-next-line no-useless-concat
                      document.cookie = "selShippingPrice=" + app._formatMoney(0) + ";path=/;";
                      $('.total_cart_price h6 span').text(app._formatMoney(app.cart.total_price));
                    } else if (tot_ship_val != 0) {
                      app.cart.chck2TotalShipPrice = tot_ship_val.toFixed(2);
                      $('.total_shipping_price h6 span').text(app._formatMoney(tot_ship_val * 100));
                      $('.total_shipping_price').removeClass('d-none');
                      // eslint-disable-next-line no-useless-concat
                      document.cookie = "selShippingPrice=" + app._formatMoney(tot_ship_val * 100) + ";path=/;";
                      $('.total_cart_price h6 span').text(app._formatMoney(app.cart.total_price + tot_ship_val * 100));
                    } else {
                      // $('.total_shipping_price').addClass('d-none');
                      $('.total_shipping_price h6 span').text(app._formatMoney(0));
                      $('.total_shipping_price').removeClass('d-none');
                      document.cookie = "selShippingPrice=" + app._formatMoney(0) + ";path=/;";
                      $('.total_cart_price h6 span').text(app._formatMoney(app.cart.total_price + tot_ship_val * 100));
                    }
                  }
                });
              } else {
                if (window.theme.offerFreeShipEnabled && window.theme.offerFreeShipAmount != '' && parseFloat(window.theme.offerFreeShipAmount) <= parseFloat(app.cart.total_price / 100000)) {
                  // app.cart.chck2TotalShipPrice = tot_ship_val.toFixed(2);
                  $('.total_shipping_price h6 span').text(app._formatMoney(0));
                  $('.total_shipping_price').removeClass('d-none');
                  // eslint-disable-next-line no-useless-concat
                  document.cookie = "selShippingPrice=" + app._formatMoney(0) + ";path=/;";
                  $('.total_cart_price h6 span').text(app._formatMoney(app.cart.total_price));
                }
              }
            }
          }, 200);
        }

        app.cart.chck2DeliveryDates = delveryDates;
        app.cart.chck2DeliveryDatesTF = delveryDatesTF;

        app.cart.chck2PreorerDates = preorderDates;

        app.cart.chck2DeliverySellers = delverySellers;
        app.cart.chck2Vendors = delverySellersVend;

        app.cart.chck2PickStores = pickStores;

        app.cart.clickPickup = 0;

        app._initCartUpsells();
        app._initCartPromos();
      }));
    },
    _addWarrProd: function _addWarrProd(variant, subRendom, event) {
      var targetEle = $(event.currentTarget);
      var warrText = $(targetEle).data('warr-text');
      var warrPrice = $(targetEle).data('warr-price');
      warrPrice = "+ " + warrPrice;
      $(targetEle).parents('[data-cart-item]').find('[data-select-text]').html(warrText);
      $(targetEle).parents('[data-cart-item]').find('[data-select-price]').html(warrPrice);
      $(targetEle).parents('[data-cart-item]').find('[data-select-price]').parent('span').removeClass('d-none');
      var warranty_qty = $(targetEle).parents('[data-cart-item]').find('.card').attr('data-waranty-qty');
      var subRendomNo = subRendom;
      var properties = {};
      var Idx = void 0;
      $(app.cart.items).each(function (index, item) {
        if (item.properties != undefined && item.properties.random_no != undefined) {
          var Random_no = item.properties.random_no.toString();
          if (Random_no == subRendomNo) {
            Idx = index + 1;
            app.isLoading = true;
            axios.post('/cart/change.js', {
              quantity: 0,
              line: Idx
            }).then(function (response) {
              app.isLoading = false;
            }).catch(function (error) {
              throw error;
            });
          }
        }
      });

      properties.random_no = subRendomNo;
      properties.product_type = 'warranty';
      setTimeout(function () {
        axios.post('/cart/add.js', {
          quantity: warranty_qty,
          id: variant,
          properties: properties
        }).then(function (response) {
          setTimeout(function () {
            targetEle.parents('[data-warr-check]').find('[data-update-warr]').addClass('d-none').removeClass('d-block');
            targetEle.siblings('[data-update-warr]').addClass('d-block').removeClass('d-none');
          }, 500);
          app._vibrateDevice();
          setTimeout(function () {
            app._getCartData();
          }, 200);
        }).catch(function (error) {
          throw error;
        });
      }, 300);
    },
    _removeWarrProd: function _removeWarrProd(subRendom, event) {
      var targetEle = $(event.currentTarget);
      $(targetEle).parents("[data-subrandom-no=" + subRendom + "]").find('.after-select').addClass('d-none').removeClass('d-flex');
      $(targetEle).parents("[data-subrandom-no=" + subRendom + "]").find('.before-select').addClass('d-flex').removeClass('d-none');
      $(targetEle).parents("[data-subrandom-no=" + subRendom + "]").find('.after-select [data-warr-text]').html('');
      $(targetEle).parents("[data-subrandom-no=" + subRendom + "]").parents('[data-cart-item]').find('[data-select-price]').html('');
      $(targetEle).parents("[data-subrandom-no=" + subRendom + "]").parents('[data-cart-item]').find('[data-select-price]').parent('span').addClass('d-none');
      var warrPrice = $(targetEle).data('warr-price');
      warrPrice = "+ " + warrPrice;

      var subRendomNo = subRendom;
      var Idx = void 0;

      $(app.cart.items).each(function (index, item) {
        if (item.properties != undefined && item.properties.random_no != undefined) {
          var Random_no = item.properties.random_no.toString();
          if (Random_no == subRendomNo) {
            Idx = index + 1;
            app.isLoading = true;
            axios.post('/cart/change.js', {
              quantity: 0,
              line: Idx
            }).then(function (response) {
              $(targetEle).siblings('[data-radio]').prop('checked', false);
              $(targetEle).addClass('d-none').removeClass('d-block');
              app.isLoading = false;
              app._getCartData();
            }).catch(function (error) {
              throw error;
            });
          }
        }
      });
    },
    _addInstallProd: function _addInstallProd(variant, subRendom, qtyValue, event) {
      var mainRendom = subRendom.replace('-1', '');
      var subRendomNo = subRendom;
      var properties = {};
      var Idx = void 0;
      if (qtyValue != undefined) {
        var qtyx = qtyValue;
      } else {
        var qtyx = 1;
      }

      var mainPrd = $("[data-cart-item][data-random-no=" + mainRendom + "]").data('variant-id');
      var chck_mainPrd = app.cart.items.find(function (item) {
        return item.variant_id === parseInt(mainPrd);
      });

      if (chck_mainPrd && chck_mainPrd != undefined) {
        properties.delivery_date = chck_mainPrd.properties.delivery_date;
        properties.fulfillment_date = chck_mainPrd.properties.fulfillment_date;
        properties.pick_available = chck_mainPrd.properties.pick_available;
        if (chck_mainPrd.properties.range_date && chck_mainPrd.properties.range_date != undefined) {
          properties.range_date = chck_mainPrd.properties.range_date;
        }
        properties.pickup_date = chck_mainPrd.properties.pickup_date;
        properties.shipping_price = '0';
        properties.shipping_store = chck_mainPrd.properties.shipping_store;
        properties.shipping_storeid = chck_mainPrd.properties.shipping_storeid;
        properties.shipping_type = chck_mainPrd.properties.shipping_type;
        properties.tags = app.InstPrdDetails.tags;
      }

      $(app.cart.items).each(function (index, item) {
        if (item.properties != undefined && item.properties.random_no != undefined) {
          var Random_no = item.properties.random_no.toString();
          if (Random_no == subRendomNo) {
            Idx = index + 1;
            app.isLoading = true;
            axios.post('/cart/change.js', {
              quantity: 0,
              line: Idx
            }).then(function (response) {
              app.isLoading = false;
            }).catch(function (error) {
              throw error;
            });
          }
        }
      });

      properties.random_no = subRendomNo;
      if (chck_mainPrd.properties.tags.indexOf('product_grill_assembly') > 0) {
        properties.product_type = 'Grill assembly';
      } else {
        properties.product_type = 'Installation';
      }

      setTimeout(function () {
        axios.post('/cart/add.js', {
          quantity: qtyx,
          id: variant,
          properties: properties
        }).then(function (response) {
          setTimeout(function () {
            $('#modalpdp').modal('hide');
            $("[data-subrandom-no=" + subRendomNo + "].installation-before").addClass('d-none');
            $("[data-subrandom-no=" + subRendomNo + "].installation-after").removeClass('d-none');
            $("[data-subrandom-no=" + subRendomNo + "].installation-after").find('.product_install').prop('checked', true).trigger('change');
            $('#app').removeClass('show-ins-overlay');
            $('.modal-backdrop').hide();
          }, 500);
          app._vibrateDevice();
          setTimeout(function () {
            app._getCartData();
          }, 200);
        }).catch(function (error) {
          throw error;
        });
      }, 300);
    },
    _removeInstallProd: function _removeInstallProd(subRendom, event) {
      var targetEle = $(event.currentTarget);
      var installPrice = $(targetEle).data('install-price');
      installPrice = "+ " + installPrice;

      var subRendomNo = subRendom;
      var Idx = void 0;

      $(app.cart.items).each(function (index, item) {
        if (item.properties != undefined && item.properties.random_no != undefined) {
          var Random_no = item.properties.random_no.toString();
          if (Random_no == subRendomNo) {
            Idx = index + 1;
            app.isLoading = true;
            axios.post('/cart/change.js', {
              quantity: 0,
              line: Idx
            }).then(function (response) {
              $("[data-subrandom-no=" + subRendomNo + "].installation-after").addClass('d-none');
              $("[data-subrandom-no=" + subRendomNo + "].installation-before").removeClass('d-none');
              // $('.installation-after').addClass('d-none');
              // $('.installation-before').removeClass('d-none');
              app.isLoading = false;
              setTimeout(function () {
                app._getCartData();
              }, 1000);
            }).catch(function (error) {
              throw error;
            });
          }
        }
      });
    },


    /**
     * Event to add a variant to the cart
     * adds item properties from hidden fields automatically
     *
     * @param  {number} variantId - current variant id
     */
    _addToCart: function _addToCart(variantId, event, reload) {
      var $this = $(event.currentTarget);
      var $actualForm = $(event.currentTarget).closest(app.selectors.productForm);
      if ($actualForm.hasClass('tool_prod_form')) {
        var $form = $actualForm.parents('body').find('form.main_prod_form');
      } else {
        var $form = $actualForm;
      }
      var $qtyEl = $form.find(app.selectors.qtyInput);
      var qtyValue = $qtyEl.val() || 1;
      var productCartLimit = $(event.currentTarget).attr('data-cart-limit') || null;
      var cartProduct = app.cart.items.find(function (x) {
        return x.variant_id === variantId;
      });
      var totalQty = cartProduct ? Number(qtyValue) + Number(cartProduct.quantity) : qtyValue;
      var properties = {};
      var propWarrVal = {};
      var propInsVal = {};
      var propGrillVal = {};
      var productAddons = app.storeUtilities.productAddons.products;
      var addonSelectedProduct = app.storeUtilities.productAddons.addonSelectedProduct + 1;
      var bundleDiscountMeta = app.product.bundleDiscountMetafields;
      var timeStamp = $('[data-timestamp]').data('timestamp');
      var randomNo = Math.floor(Math.random() * 10000);
      var warrFlag = $form.find('.has_warranty').find('input[name="warranties"]').val();

      var installFlag = $form.find('.has_installation').find('input[name="installation"]').val();

      var grillFlag = $form.find('.has_grillassembly').find('input[name="grill_assembly"]').val();

      Shopify.queue = [];
      app.recentlyAddedQty = qtyValue;

      var chck_intobj = app.cart.items.find(function (item) {
        return item.variant_id === variantId;
      });

      if (chck_intobj && chck_intobj != undefined) {
        var chck_int = parseInt(qtyValue) + parseInt(chck_intobj.quantity);
      } else {
        var chck_int = parseInt(qtyValue);
      }

      // eslint-disable-next-line block-scoped-var
      if (app.currentVariant.inventory < chck_int) {
        $qtyEl.val(1); // reset qty input to 1
        app.$snotify.clear();
        var title = 'No hay suficientes';
        var body = 'Nos quedan solo ' + app.currentVariant.inventory + ' de este producto';

        app.$snotify.error(body, title, {
          timeout: 5000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          titleMaxLength: 50,
          icon: 'https://cdn.shopify.com/s/files/1/0104/4391/5319/files/danger.png?v=1624358532',
          buttons: [{
            text: 'Cerrar',
            bold: true,
            closeOnClick: true
          }]
        });

        return false;
      }

      // add cart limit property
      if (productCartLimit) {
        properties.cart_limit = productCartLimit;
      }

      if (app.currentTemplate == 'collection' || app.currentTemplate == 'search') {
        if (!$form.hasClass('rebuy-form')) {
          if (app.quickShop.inventory == '' || app.quickShop.inventory == null) {
            properties.inventory = 0;
          } else {
            properties.inventory = app.quickShop.inventory.toString();
          }

          properties.SKU = app.quickShop.currentVariant.sku;

          if (app.quickShop.product.tags == '') {
            properties.tags = '';
          } else {
            properties.tags = app.quickShop.product.tags.toString();
          }

          if (app.quickShop.product.chck2del24h == 'yes') {
            localStorage.setItem('allow24hDelBlk', 'true');
          }
        }
      } else if (app.currentTemplate == 'kitchen-box') {} else {
        if (!$form.hasClass('rebuy-form')) {
          if (app.currentVariant.inventory == '' || app.currentVariant.inventory == null) {
            properties.inventory = 0;
          } else {
            properties.inventory = app.currentVariant.inventory.toString();
          }

          properties.SKU = app.currentVariant.sku;

          if (app.product.tags == '') {
            properties.tags = '';
          } else {
            properties.tags = app.product.tags.toString();
          }

          if (app.product.chck2del24h == 'yes') {
            localStorage.setItem('allow24hDelBlk', 'true');
          }
        }
      }

      var same_prd = app.cart.items.find(function (item) {
        return item.variant_id === variantId;
      });

      var same_warranty_prd = app.cart.items.find(function (item) {
        return item.variant_id === parseInt(app.WarrantyVariantID) && item.product_type == 'Warranty';
      });

      var same_install_prd = app.cart.items.find(function (item) {
        return item.variant_id === parseInt(app.installVariantId) && item.product_type == 'Installation';
      });

      if (same_prd) {
        properties.random_no = same_prd.properties.random_no;
        app.recentlyAddedIdentifier = same_prd.properties.random_no;

        if (window.theme.offerFreeShipEnabled && window.theme.offerFreeShipAmount != '' && parseFloat(window.theme.offerFreeShipAmount) <= parseFloat(app.cart.total_price / 100000)) {
          properties.total_shipping = '0';
        } else {
          properties.total_shipping = same_prd.properties.total_shipping;
        }
      } else {
        if (warrFlag != '' && warrFlag != undefined && warrFlag == 'yes') {
          if (randomNo != undefined) {
            randomNo += '-0';
            properties.random_no = randomNo;
            app.recentlyAddedIdentifier = randomNo;
          } else {
            alert('Something is wrong! Please try again');
            return;
          }
        }
        if (installFlag != '' && installFlag != undefined && installFlag == 'yes') {
          if (randomNo != undefined) {
            randomNo += '-0';
            properties.random_no = randomNo;
            app.recentlyAddedIdentifier = randomNo;
          } else {
            alert('Something is wrong! Please try again');
            return;
          }
        }
        if (grillFlag != '' && grillFlag != undefined && grillFlag == 'yes') {
          if (randomNo != undefined) {
            randomNo += '-0';
            properties.random_no = randomNo;
            app.recentlyAddedIdentifier = randomNo;
          } else {
            alert('Something is wrong! Please try again');
            return;
          }
        }
      }

      // check if item has product limit assigned
      if (app._productHasCartLimit(totalQty, productCartLimit)) {
        return;
      }

      app.isLoading = true;
      app.loadingEvent = 'cartAdding';

      // Pass all properties to the cart line item
      if (app.currentTemplate == 'kitchen-box') {
        $.each($this.parents('[data-boxnumber]').find('.add_prop_div').find('input[name*="properties"]').serializeArray(), function () {
          var name = this.name.replace('properties[', '').replace(']', '');
          properties[name] = this.value;
          if (name != 'weight') {
            propWarrVal[name] = this.value;
            propInsVal[name] = this.value;
            propGrillVal[name] = this.value;
          }
          if (name == 'shipping_price') {
            propWarrVal[name] = '0';
            propInsVal[name] = '0';
            propGrillVal[name] = '0';
          }
        });
      } else {
        $.each($form.find('input[name*="properties"]').serializeArray(), function () {
          var name = this.name.replace('properties[', '').replace(']', '');
          properties[name] = this.value;
          if (name != 'weight') {
            propWarrVal[name] = this.value;
            propInsVal[name] = this.value;
            propGrillVal[name] = this.value;
          }
          if (name == 'shipping_price') {
            propWarrVal[name] = '0';
            propInsVal[name] = '0';
            propGrillVal[name] = '0';
          }
        });
      }

      // if product has a add on products then add these properties to parent product
      if (productAddons.length > 0 && addonSelectedProduct !== null && addonSelectedProduct !== 0) {
        properties._main_bundle_product = 'true';
        properties._bundle_product = 'true';
        if (addonSelectedProduct === 2) {
          properties._bundle_product_discount = bundleDiscountMeta.BundleProductDiscount1 + "_" + addonSelectedProduct + "_" + timeStamp;
        } else if (addonSelectedProduct === 3) {
          properties._bundle_product_discount = bundleDiscountMeta.BundleProductDiscount2 + "_" + addonSelectedProduct + "_" + timeStamp;
        } else if (addonSelectedProduct === 4) {
          properties._bundle_product_discount = bundleDiscountMeta.BundleProductDiscount3 + "_" + addonSelectedProduct + "_" + timeStamp;
        }
        if (warrFlag != '' && warrFlag != undefined && warrFlag == 'yes') {
          if (randomNo != undefined) {
            randomNo += '-0';
            properties.random_no = randomNo;
            app.recentlyAddedIdentifier = randomNo;
          } else {
            alert('Something is wrong! Please try again');
            return;
          }
        }
        if (installFlag != '' && installFlag != undefined && installFlag == 'yes') {
          if (randomNo != undefined) {
            randomNo += '-0';
            properties.random_no = randomNo;
            app.recentlyAddedIdentifier = randomNo;
          } else {
            alert('Something is wrong! Please try again');
            return;
          }
        }
        if (grillFlag != '' && grillFlag != undefined && grillFlag == 'yes') {
          if (randomNo != undefined) {
            randomNo += '-0';
            properties.random_no = randomNo;
            app.recentlyAddedIdentifier = randomNo;
          } else {
            alert('Something is wrong! Please try again');
            return;
          }
        }
      }

      // push the default variantId to the Shopify queue
      Shopify.queue.push({
        variantId: variantId,
        properties: properties
      });

      // if there are selected product add-ons
      // push them also to the Shopify queue
      if (productAddons.length > 0) {
        productAddons.forEach(function (product) {
          var propAddonVal = {};
          propAddonVal._bundle_product = 'true';
          propAddonVal.inventory = product.variants[0].inventory_quantity;
          if (addonSelectedProduct === 2) {
            propAddonVal._bundle_product_discount = bundleDiscountMeta.BundleProductDiscount1 + "_" + addonSelectedProduct + "_" + timeStamp;
          } else if (addonSelectedProduct === 3) {
            propAddonVal._bundle_product_discount = bundleDiscountMeta.BundleProductDiscount2 + "_" + addonSelectedProduct + "_" + timeStamp;
          } else if (addonSelectedProduct === 4) {
            propAddonVal._bundle_product_discount = bundleDiscountMeta.BundleProductDiscount3 + "_" + addonSelectedProduct + "_" + timeStamp;
          }

          if (product.selected) {
            Shopify.queue.push({
              variantId: product.variants[0].id,
              properties: propAddonVal
            });
          }
        });
      }

      if (app.WarrantyProductsHandle != '') {
        var warrantyVariantid = app.WarrantyVariantID;
        if (same_prd) {
          // const identifier = `${app.recentlyAddedIdentifier}-${same_warranty_prd.quantity}`;
          if (same_warranty_prd) {
            propWarrVal.random_no = app.recentlyAddedIdentifier + "-" + (same_warranty_prd.quantity + 1);
            propWarrVal.product_type = 'warranty';
            Shopify.queue.push({
              variantId: warrantyVariantid,
              properties: propWarrVal
            });
          } else {
            propWarrVal.random_no = app.recentlyAddedIdentifier + "-" + (same_prd.quantity + 1);
            propWarrVal.product_type = 'warranty';
            Shopify.queue.push({
              variantId: warrantyVariantid,
              properties: propWarrVal
            });
          }
        } else {
          // const identifier = `${app.recentlyAddedIdentifier}-1`;
          propWarrVal.random_no = app.recentlyAddedIdentifier + "-1";
          propWarrVal.product_type = 'warranty';
          Shopify.queue.push({
            variantId: warrantyVariantid,
            properties: propWarrVal
          });
        }
        // Shopify.queue.push({
        //   variantId: warrantyVariantid,
        //   properties: {
        //     random_no: identifier,
        //   },
        // });
      }

      if (installFlag != '' && installFlag != undefined && installFlag == 'yes') {
        if (app.installProductHandle != '' && app.isTermsChecked == true) {
          var installVariantid = app.installVariantId;
          var installProdTags = app.installProdTags;

          if (same_prd) {
            if (same_install_prd) {
              propInsVal.random_no = app.recentlyAddedIdentifier + "-1";
              propInsVal.product_type = 'Installation';
              propInsVal.tags = installProdTags;
              Shopify.queue.push({
                variantId: installVariantid,
                properties: propInsVal
              });
            } else {
              propInsVal.random_no = app.recentlyAddedIdentifier + "-1";
              propInsVal.product_type = 'Installation';
              propInsVal.tags = installProdTags;
              Shopify.queue.push({
                variantId: installVariantid,
                properties: propInsVal
              });
            }
          } else {
            propInsVal.random_no = app.recentlyAddedIdentifier + "-1";
            propInsVal.product_type = 'Installation';
            propInsVal.tags = installProdTags;
            Shopify.queue.push({
              variantId: installVariantid,
              properties: propInsVal
            });

            //  **old logic**
            // var parseqtyValue = parseInt(qtyValue);
            // for (let i = 1; i <= parseqtyValue; i++) {
            //   Shopify.queue.push({
            //     variantId: installVariantid,
            //     properties: {
            //       random_no: `${app.recentlyAddedIdentifier}-${i}`,
            //       product_type: 'Installation',
            //     },
            //   });
            // }
          }
        }
      }

      if (grillFlag != '' && grillFlag != undefined && grillFlag == 'yes') {
        if (app.grillProductHandle != '') {
          var grillVariantid = app.grillVariantId;
          var grillProdTags = app.grillProdTags;
          if (same_prd) {
            if (same_grill_prd) {
              propGrillVal.random_no = app.recentlyAddedIdentifier + "-1";
              propGrillVal.product_type = 'Grill assembly';
              propGrillVal.tags = grillProdTags;
              Shopify.queue.push({
                variantId: grillVariantid,
                properties: propGrillVal
              });
            } else {
              propGrillVal.random_no = app.recentlyAddedIdentifier + "-1";
              propGrillVal.product_type = 'Grill assembly';
              propGrillVal.tags = grillProdTags;
              Shopify.queue.push({
                variantId: grillVariantid,
                properties: propGrillVal
              });
            }
          } else {
            propGrillVal.random_no = app.recentlyAddedIdentifier + "-1";
            propGrillVal.product_type = 'Grill assembly';
            propGrillVal.tags = grillProdTags;
            Shopify.queue.push({
              variantId: grillVariantid,
              properties: propGrillVal
            });
            //  **old logic**	
            // var parseqtyValue = parseInt(qtyValue);	
            // for (let i = 1; i <= parseqtyValue; i++) {	
            //   Shopify.queue.push({	
            //     variantId: installVariantid,	
            //     properties: {	
            //       random_no: `${app.recentlyAddedIdentifier}-${i}`,	
            //       product_type: 'Installation',	
            //     },	
            //   });	
            // }	
          }
        }
      }

      Shopify.moveAlong = function () {
        // If we still have requests in the queue, let's process the next one.
        if (Shopify.queue.length) {
          var request = Shopify.queue.shift();
          axios.post('/cart/add.js', {
            quantity: qtyValue,
            id: request.variantId,
            properties: request.properties
          }).then(function (response) {
            if ($form.length > 0) {
              // Klaviyo tracking
              if (app.currentTemplate != 'collection') {
                var item = {
                  Name: app.product.title,
                  ProductID: app.product.id,
                  category: app.product.type,
                  ImageURL: "https:" + app.product.featured_image,
                  URL: "https://kitchencenter.cl/products/" + app.product.handle,
                  Brand: app.product.vendor,
                  Price: app._formatMoney(app.currentVariant.price),
                  CompareAtPrice: app._formatMoney(app.currentVariant.compare_at_price)
                };
                _learnq.push(['track', 'Added to Cart', item]);
              } else {
                var item = {
                  Name: app.quickShop.product.title,
                  ProductID: app.quickShop.product.id,
                  category: app.quickShop.product.type,
                  ImageURL: "https:" + app.quickShop.product.featured_image,
                  URL: "https://kitchencenter.cl" + app.quickShop.product.url,
                  Brand: app.quickShop.product.vendor,
                  Price: app._formatMoney(app.quickShop.currentVariant.price),
                  CompareAtPrice: app._formatMoney(app.quickShop.currentVariant.compare_at_price)
                };
                _learnq.push(['track', 'Added to Cart', item]);
              }
              // HawkSearch Event Tracking
              var proPrice = $form.attr('data-price');
              proPrice = proPrice.replace('$', '');

              HawkSearch.Tracking.track('add2cart', {
                uniqueId: $form.attr('data-hawkid'),
                price: proPrice,
                quantity: qtyValue,
                currency: 'CLP'
              });

              dataLayer.push({
                event: 'addToCart',
                ecommerce: {
                  currencyCode: 'CLP',
                  add: { // 'add' actionFieldObject measures.
                    products: [{ //  adding a product to a shopping cart.
                      name: app.product.title,
                      id: app.product.id,
                      price: app._formatMoney(app.currentVariant.price),
                      sku: app.currentVariant.sku,
                      brand: app.product.vendor,
                      category: app.product.type,
                      variant: app.currentVariant.title,
                      quantity: qtyValue
                    }]
                  }
                }
              });
            }

            Shopify.moveAlong();
            return response.data;
          }).catch(function (error) {
            if (Shopify.queue.length) {
              Shopify.moveAlong();
            }
            throw error;
          });
        } else {
          if (app.currentTemplate === 'cart' && !app.isCartAjaxed) {
            location.reload();
          }

          app._getCartData();
          app._rebuyCartPageWidgetUpdate();
          app._vibrateDevice();
          $qtyEl.val(1); // reset qty input to 1
          app.$snotify.clear();

          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;

            /*  add this once smart cart is on  */
            if (app.currentTemplate == 'collection' || app.currentTemplate == 'product' || app.currentTemplate == 'search') {
              $('[data-template="quickshop"]').modal('hide');
              app.isCartDrawerOpen = false;

              if (app.currentTemplate == 'product') {} else {
                // app._toggleCartDrawer();	
              }
            } else {
              if (!$form.hasClass('rebuy-form')) {
                window.location.href = '/cart';
              }
            }

            if (app.storeUtilities.cartUpsells.settings.showOnPopUp) {
              var recentItem = app.cart.items.find(function (x) {
                return x.variant_id === variantId;
              });
              app._openModalCartUpsell(recentItem);
            } else {
              // app._toggleCartDrawer();
            }
          }, 500);
        }
      };
      Shopify.moveAlong();
      if ($('[data-regions]').val() != null && $('[data-regions]').val() != '') {
        document.cookie = 'selectedRegion=' + $('[data-regions]').val() + ';path=/' + ';';
        if (app._getCookie('selCommonC') && app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '' && app._getCookie('selCommonC') != 'selCommonC') {} else {
          document.cookie = 'selCommonR=' + $('[data-regions]').val() + ';path=/' + ';';
        }
      }
      if ($('[data-district]').val() != null && $('[data-district]').val() != '') {
        document.cookie = 'selectedComuna=' + $('[data-district]').val() + ';path=/' + ';';
        if (app._getCookie('selCommonC') && app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '' && app._getCookie('selCommonC') != 'selCommonC') {} else {
          document.cookie = 'selCommonC=' + $('[data-district]').val() + ';path=/' + ';';
          document.cookie = 'selectedTimestamp=' + new Date().getTime() + ';path=/' + ';';
        }
      }
    },
    _isInViewport: function _isInViewport() {
      if ($('[data-checkoutBox]').length > 0) {
        var elementTop = $('[data-checkoutBox]').offset().top;
        var elementBottom = elementTop + $('[data-checkoutBox]').outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          app.cartinViewport = true;
        } else {
          app.cartinViewport = false;
        }
      }
    },
    _getProductDataAnalytics: function _getProductDataAnalytics(handle) {
      var selectedProduct = [];
      // eslint-disable-next-line promise/catch-or-return
      axios.get("/products/" + handle + ".js").then(function (response) {
        selectedProduct.push(response.data);
      });
      return selectedProduct;
    },


    /**
     * Event to remove a variant from the cart
     *
     * @param  {number} itemId - line item index
     */
    _removeFromCart: function _removeFromCart(itemIndex, event) {

      var $cartItem = $(event.currentTarget).parentsUntil(app.selectors.cartItem).parent();
      var mainRandNo = $($cartItem).attr('data-random-no');
      var proHandle = $(event.currentTarget).data('handle');
      var proDataAnalytics = app._getProductDataAnalytics(proHandle);
      var selectedVariantsSku = $(event.currentTarget).data('handle');
      var selectedVariantsVariant = $(event.currentTarget).data('variant');
      var selectedVariantId = $(event.currentTarget).data('id');
      if ($(event.currentTarget).data('installation') != undefined) {
        var isInstallation = $(event.currentTarget).data('installation');
      } else {
        var isInstallation = false;
      }

      app.isLoading = true;
      $cartItem.addClass('updating');

      if (mainRandNo != undefined && isInstallation != true) {
        var $prodArr = {};
        var $prodQTY = [];
        $(app.cart.items).each(function (index, item) {
          var subrand = item.properties.random_no;
          var varId = item.variant_id;
          var varQty = item.quantity;
          if (subrand != undefined) {
            if (subrand.indexOf(mainRandNo) != -1) {
              varQty = 0;
            }
          }
          $prodQTY.push(varQty);
          $prodArr[varId] = varQty;
        });

        axios.post('/cart/update.js', {
          // updates: $prodArr
          updates: $prodQTY
        }).then(function (response) {
          app.isLoading = false;
          app._getCartData();
          app._rebuyCartPageWidgetUpdate();
          if (app.currentTemplate == 'product' && $('.product_install').is(':checked')) {
            $('.product_install').prop('checked', false).trigger('change');
            $('#accept_terms').prop('checked', false).trigger('change');
          }
          dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
              remove: { // 'add' actionFieldObject measures.
                products: [{ //  adding a product to a shopping cart.
                  name: proDataAnalytics[0].title,
                  id: selectedVariantId,
                  productId: proDataAnalytics[0].id,
                  price: app._formatMoney(proDataAnalytics[0].price),
                  sku: selectedVariantsSku,
                  brand: proDataAnalytics[0].vendor,
                  variant: selectedVariantsVariant,
                  quantity: 0,
                  category: proDataAnalytics[0].type,
                  item_count: response.data.item_count,
                  total_cost: app._formatMoney(response.data.total_price),
                  cart_id: response.data.token
                }]
              }
            }
          });
          $('[data-toggle="tooltip"]').tooltip('hide');
          return response;
        }).catch(function (error) {
          throw error;
        });
      } else {
        axios.post('/cart/change.js', {
          quantity: 0,
          line: itemIndex
        }).then(function (response) {
          app.isLoading = false;
          setTimeout(function () {
            app._getCartData();
            app._rebuyCartPageWidgetUpdate();
          }, 200);
          if (app.currentTemplate == 'product' && $('.product_install').is(':checked')) {
            $('.product_install').prop('checked', false).trigger('change');
            $('#accept_terms').prop('checked', false).trigger('change');
          }
          dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
              remove: { // 'add' actionFieldObject measures.
                products: [{ //  adding a product to a shopping cart.
                  name: proDataAnalytics[0].title,
                  id: selectedVariantId,
                  productId: proDataAnalytics[0].id,
                  price: app._formatMoney(proDataAnalytics[0].price),
                  sku: selectedVariantsSku,
                  brand: proDataAnalytics[0].vendor,
                  variant: selectedVariantsVariant,
                  quantity: 0,
                  category: proDataAnalytics[0].type,
                  item_count: response.data.item_count,
                  total_cost: app._formatMoney(response.data.total_price),
                  cart_id: response.data.token
                }]
              }
            }
          });
          $('[data-toggle="tooltip"]').tooltip('hide');
          return response;
        }).catch(function (error) {
          throw error;
        });
      }
    },


    /**
     * Event to update a variant in the cart
     *
     * @param  {number} itemIndex - line item index
     */
    _updateCart: function _updateCart(itemIndex, event) {
      var $qtyEl = $(event.currentTarget).parentsUntil(app.selectors.qtyContainer).find(app.selectors.qtyInput);
      var $cartItem = $(event.currentTarget).closest(app.selectors.cartItem);
      var productCartLimit = $cartItem.data('cart-limit') || null;
      var qtyValue = $qtyEl.val();
      app.cartError = false;
      var deleteSubItems = false;

      var addSubItems = false;
      var addSubItemsId = '';
      var addSubItemsRenProp = '';

      var decreseSubItems = false;
      var decreseSubItemsId = '';
      var decreseSubItemsRenProp = '';
      var randNo = $cartItem.data('random-no') + "-" + qtyValue;
      var randNoInc = $cartItem.data('random-no') + "-1";
      var subIdx = void 0;

      if ($(event.currentTarget).data('qty-decrease') !== undefined) {
        if (qtyValue == 1) {
          return false;
        }
        if (parseFloat(qtyValue) >= 2) {
          qtyValue = parseFloat(qtyValue) - 1;
          $(app.cart.items).each(function (index, value) {
            if (value.properties != undefined && value.properties.random_no != undefined) {
              var subRandom_no = value.properties.random_no.toString();
              if (subRandom_no == randNoInc) {
                subIdx = index + 1;
                if (app.cart.items[index].product_type == 'Installation' || app.cart.items[index].product_type == 'Grill assembly') {
                  decreseSubItems = true;
                  decreseSubItemsId = value.id;
                  decreseSubItemsRenProp = subRandom_no;
                }
              } else if (subRandom_no == randNo) {
                subIdx = index + 1;
                deleteSubItems = true;
              }
            }
          });
        }
      } else if ($(event.currentTarget).data('qty-increase') !== undefined) {
        qtyValue = parseFloat(qtyValue) + 1;

        $(app.cart.items).each(function (index, value) {
          if (value.properties != undefined && value.properties.random_no != undefined) {
            var subRandom_no = value.properties.random_no.toString();
            if (subRandom_no == randNoInc) {
              subIdx = index + 1;
              if (app.cart.items[index].product_type == 'Installation' || app.cart.items[index].product_type == 'Grill assembly') {
                addSubItems = true;
                addSubItemsId = value.id;
                addSubItemsRenProp = subRandom_no;
              }
            }
          }
        });
        // check if item has product limit assigned
        if (app._productHasCartLimit(qtyValue, productCartLimit)) {
          app.cartError = true;
          return;
        }
      }

      app.isLoading = true;
      $cartItem.addClass('updating');

      $($qtyEl).parent().css({
        'pointer-events': 'none'
      });

      axios.post('/cart/change.js', {
        quantity: qtyValue,
        line: itemIndex
      }).then(function (response) {
        // app._getCartData();
        app.isLoading = false;
        $cartItem.removeClass('updating');
        if (addSubItems == true) {
          app._addInstallProd(addSubItemsId, addSubItemsRenProp, qtyValue);
        } else if (decreseSubItems == true) {
          app._addInstallProd(decreseSubItemsId, decreseSubItemsRenProp, qtyValue);
        } else if (deleteSubItems == true) {
          app._removeWarrentyFromCart(subIdx);
        } else {
          app._getCartData();
        }
        $($qtyEl).parent().css({
          'pointer-events': 'inherit'
        });
        return response;
      }).catch(function (error) {
        throw error;
      });
    },
    _decreseInstallProd: function _decreseInstallProd(index, qty) {
      axios.post('/cart/change.js', {
        quantity: 2,
        line: parseInt(index)
      }).then(function (response) {
        app._getCartData();
      });
    },
    _removeWarrentyFromCart: function _removeWarrentyFromCart(index) {
      app.isLoading = true;
      axios.post('/cart/change.js', {
        quantity: 0,
        line: index
      }).then(function (response) {
        app.isLoading = false;
        app._getCartData();
      }).catch(function (error) {
        throw error;
      });
    },
    _productHasCartLimit: function _productHasCartLimit(qtyValue, productCartLimit) {
      if (productCartLimit) {
        if (qtyValue > productCartLimit) {
          app.$snotify.warning("Product cart limit applies for the specific product variant. You can't purchase more than " + productCartLimit + " item(s) per order.", 'Product Limit', {
            timeout: 10000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            buttons: [{
              text: 'Close',
              bold: true,
              closeOnClick: true
              // action: (toast) => {
              //   app.$snotify.remove(toast.id);
              // },
            }]
          });
          return true;
        }
      }
      return false;
    },


    /**
     * ShippingCalculator
     */
    _initShippingCalculator: function _initShippingCalculator() {
      var $form = $('[data-shipping-calculator]');
      if ($form.length === 0) {
        return;
      }

      var customerCountry = $form.find('select[name="country"]').data('value').trim();
      var customerProvince = $form.find('select[name="province"]').data('value').trim();
      var customerZip = $form.find('input[name="zip"]').data('value').trim();
      var userCountry = app._getCookie('user_country');
      var userProvince = app._getCookie('user_province');
      var today = new Date();
      var expirationDate = new Date();
      expirationDate.setDate(today.getDate() + 7);
      var time = expirationDate.getTime();
      var expireTime = time + 1000 * 36000;
      expirationDate.setTime(expireTime);

      if (customerCountry) {
        // if is user (is logged-in) show the user data
        app.selectedCountry = customerCountry;
        app.selectedProvince = customerProvince;
        app.selectedZip = customerZip;
      } else if (userCountry !== 'user_country' && userProvince !== 'user_province') {
        // else if cookie exists get from cookie
        app.selectedCountry = userCountry;
        app.selectedProvince = userProvince;
      } else {
        // finally if we don't have any data => get info from IP
        axios.get('https://geoip-db.com/json/').then(function (response) {
          app.selectedCountry = response.data.country_name;
          app.selectedProvince = response.data.region_name;
          // app.selectedZip = response.data.zip_code

          // set cookies
          document.cookie = "user_country=" + response.data.country_name + ";expires=" + expirationDate.toGMTString() + ";path=/";
          document.cookie = "user_province=" + response.data.region_name + ";expires=" + expirationDate.toGMTString() + ";path=/";
          return response;
        }).catch(function (error) {
          throw error;
        });
      }
    },
    _getCartShippingRates: function _getCartShippingRates() {
      app.isLoading = true;

      axios.post('/cart/prepare_shipping_rates', {
        shipping_address: {
          country: app.selectedCountry,
          province: app.selectedProvince,
          zip: app.selectedZip
        }
      }).then(function (response) {
        app._pollCartShippingRates();
        return response;
      }).catch(function (error) {
        app.isLoading = false;
        app.shippingRatesErrors = error.response.data;
        throw error;
      });
    },
    _pollCartShippingRates: function _pollCartShippingRates() {
      axios.get('/cart/async_shipping_rates').then(function (response) {
        app.isLoading = false;
        if (response.data && response.data.shipping_rates) {
          app.shippingRates = response.data.shipping_rates;
        }
        return response;
      }).catch(function (error) {
        throw error;
      });
    },


    /**
     * Vibrate mobile device
     */
    _vibrateDevice: function _vibrateDevice() {
      // check for vibration support
      var vibrationEnabled = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
      if (vibrationEnabled) {
        navigator.vibrate(100);
      }
    },
    _openCartStoreModal: function _openCartStoreModal(event) {
      var $this = $(event.currentTarget);

      var thisVarid = $this.attr('data-variantpop-id');
      var thisShipType = $this.attr('data-shipp_type');
      var change_shipping_type = $this.attr('data-change_shipping_type');
      var thisItem = app.cart.items.find(function (item) {
        return parseInt(item.variant_id) === parseInt(thisVarid);
      });
      var selStore = thisItem.properties.shipping_storeid;

      $('[data-shipping-check]').attr('data-variantpop-id', thisVarid);
      $('[data-shipping-check]').attr('data-shipp_type', thisShipType);
      $('[data-shipping-check]').attr('data-change_shipping_type', change_shipping_type);

      // $('body').addClass('showtoggle');

      $('#ship-address, #ship-address-noa ,#address2, #address2-noa,[data-regions],[data-district]').addClass('d-none');

      $('#modalForShipping .modal-header ').removeClass('d-none').addClass('pb-0');
      $('#modalForShipping .modal-header #exampleModalLongTitle').removeClass('d-none');
      $('#modalForShipping .modal-body #exampleModalLongTitle').addClass('d-none');

      if ($('[data-shipping-check]').attr('data-shipp_type') == 'pickup' || thisShipType == 'pickup') {

        $('.checkbox-wrapper, .numeric_error, .addlength_error, .numeric_only_error').addClass('d-none');

        $('#modalForShipping').removeClass('showtoggle').addClass('showpopup');
        $('#modalForShipping .modal-dialog').removeClass('m-0').addClass('modal-dialog-centered modal-sm');
        $('#app').removeClass('showtoggle').addClass('showpopup');

        // if($('[data-stores]').val() == '' || $('[data-stores]').val() == null){
        $('[data-store-update]').addClass('button-hidden');
        // }
      }

      $('[data-shipping-check]').addClass('d-none');
      $('[data-store-update]').removeClass('d-none');

      var regionsJson = void 0;
      var regionsLocalStrg = localStorage.getItem('regionsJsonLS');
      if (regionsLocalStrg && regionsLocalStrg != '' && regionsLocalStrg != undefined) {
        var regions = JSON.parse(regionsLocalStrg);
        regionsJson = regions;
        var homeRegion = '<option disabled selected value="">Región</option>';
        var count = 0;
        var checkReg = '';
        $.each(regions, function () {
          $.each(this, function (k, value) {
            if (value.region != 'Regi') {
              if (value.region != 'Portugal') {
                if (app.selectedRegion != null && app.selectedRegion != '' && app.selectedRegion == value.region) {
                  checkReg = ' selected="selected"';
                } else {
                  checkReg = '';
                }
                if (count == 0) {
                  homeRegion += '<option value="' + value.region + '" data-shortvalue="' + value.region.replace('Región de ', '').replace('Región del ', '').replace('Región ', '').toLowerCase() + '"' + checkReg + '>' + value.region + '</option>';
                } else {
                  if (homeRegion.indexOf(value.region) == -1) {
                    homeRegion += '<option value="' + value.region + '"data-shortvalue="' + value.region.replace('Región de ', '').replace('Región del ', '').replace('Región ', '').toLowerCase() + '"' + checkReg + '>' + value.region + '</option>';
                  }
                }
              }
            }
            count++;
          });
        });
        $('[data-regions]').html(homeRegion);
        setTimeout(function () {
          $('[data-regions]').trigger('change');
        }, 400);

        $('[data-regions] , [data-district]').attr('disabled', 'disabled');

        $('#modalForShipping .close').click(function () {

          $('[data-shipping-check]').removeAttr('data-change_comuna');
          $('[data-shipping-check]').removeAttr('data-change_shipping_type');

          if (change_shipping_type == 1) {
            var _thisVarid = $('#modalForShipping').find('[data-shipping-check]').attr('data-variantpop-id');

            $('[data-cart-item][data-variant-id="' + _thisVarid + '"]').find('.choose-store').find('.radio-delivery').siblings('label').trigger('click');
          }
        });
      } else {
        $.ajax({
          type: 'GET',
          url: 'https://app.kitchencenter.cl/api/calendar/regions',
          success: function success(regions) {
            regionsJson = regions;
            var homeRegion = '<option disabled selected value="">Región</option>';
            var count = 0;
            var checkReg = '';
            $.each(regions, function () {
              $.each(this, function (k, value) {
                if (value.region != 'Regi') {
                  if (value.region != 'Portugal') {
                    if (app.selectedRegion != null && app.selectedRegion != '' && app.selectedRegion == value.region) {
                      checkReg = ' selected="selected"';
                    } else {
                      checkReg = '';
                    }
                    if (count == 0) {
                      homeRegion += '<option value="' + value.region + '" data-shortvalue="' + value.region.replace('Región de ', '').replace('Región del ', '').replace('Región ', '').toLowerCase() + '"' + checkReg + '>' + value.region + '</option>';
                    } else {
                      if (homeRegion.indexOf(value.region) == -1) {
                        homeRegion += '<option value="' + value.region + '"data-shortvalue="' + value.region.replace('Región de ', '').replace('Región del ', '').replace('Región ', '').toLowerCase() + '"' + checkReg + '>' + value.region + '</option>';
                      }
                    }
                  }
                }
                count++;
              });
            });
            $('[data-regions]').html(homeRegion);
            $('[data-regions]').trigger('change');

            $('[data-regions] , [data-district]').attr('disabled', 'disabled');

            $('#modalForShipping .close').click(function () {

              $('[data-shipping-check]').removeAttr('data-change_comuna');
              $('[data-shipping-check]').removeAttr('data-change_shipping_type');

              if (change_shipping_type == 1) {
                var _thisVarid2 = $('#modalForShipping').find('[data-shipping-check]').attr('data-variantpop-id');

                $('[data-cart-item][data-variant-id="' + _thisVarid2 + '"]').find('.choose-store').find('.radio-delivery').siblings('label').trigger('click');
              }
            });
          },
          error: function error(res) {
            console.log(res);
          }
        });
      }

      if (app.selectedRegion != null) {
        var valReg = app.selectedRegion;
      } else {
        var valReg = $this.parents('#modalForShipping').find('[data-regions]').val();
      }

      if (app.selectedComuna != null) {
        var valCom = app.selectedComuna;
      } else {
        var valCom = $this.parents('#modalForShipping').find('[data-district]').val();
      }

      var array = [];
      array.push(thisItem);
      var contains = { items: array };

      var data = {
        region: valReg,
        district: valCom,
        cart: JSON.stringify(contains)
      };

      var storesJson = void 0;
      var storeCount = 0;
      $.ajax({
        type: 'POST',
        url: 'https://app.kitchencenter.cl/api/calendar/pickup-store',
        dataType: 'json',
        data: data,
        success: function success(storesdata) {
          if (storesdata.pickup[0].stores.length > 0) {
            storesJson = storesdata.pickup[0].stores;
            var pickStore = '<option disabled selected value="">Selecciona tienda</option>';
            $.each(storesJson, function (k, value) {
              if (value.inventory > 0) {
                pickStore += '<option value="' + value.location_id + '" data-store="' + value.name + '" data-inventory="' + value.inventory + '">' + value.name + '</option>';
                storeCount = storeCount + 1;
              }
            });
            if (storeCount > 0) {
              $('[data-stores]').html(pickStore);
              $('[data-stores]').removeClass('d-none');
              $('#modalForShipping').modal('show');
              // $('[data-stores]').trigger('change');
            } else {
              $('[data-cart-item][data-variant-id="' + thisVarid + '"]').find('.choose-store').find('.radio-delivery').siblings('label').trigger('click');
              $('[data-cart-item][data-variant-id="' + thisVarid + '"]').find('.choose-store').find('.radio-pickup').siblings('label').after('<p class="text-danger no-stores ml-2 my-2 small">No hay tiendas disponibles</p>');
              $('.no-stores').delay(5000).fadeOut('slow');
              setTimeout(function () {
                $('.no-stores').remove();
              }, 6000);
            }
          } else {
            $('[data-cart-item][data-variant-id="' + thisVarid + '"]').find('.choose-store').find('.radio-delivery').siblings('label').trigger('click');
            $('[data-cart-item][data-variant-id="' + thisVarid + '"]').find('.choose-store').find('.radio-pickup').siblings('label').after('<p class="text-danger no-stores ml-2 my-2 small">No hay tiendas disponibles</p>');
            $('.no-stores').delay(5000).fadeOut('slow');
            setTimeout(function () {
              $('.no-stores').remove();
            }, 6000);
          }
        }
      });

      $('[data-regions]').change(function () {
        var val = $(this).val();
        var homeDistrict = '<option value="" disabled selected>Comuna</option>';
        var checkCom = '';
        $.each(regionsJson[val], function (k, value) {
          var disttorg = value.district;
          var distt = value.district;
          distt = distt.replace(/í/g, 'i');
          distt = distt.replace(/á/g, 'a');
          if (app.selectedComuna != null && app.selectedComuna != '' && (app.selectedComuna == disttorg || app.selectedComuna == disttorg)) {
            checkCom = ' selected="selected"';
          } else {
            checkCom = '';
          }
          homeDistrict += '<option value="' + disttorg + '" data-value="' + distt + '" data-out="' + value.is_out_of_delivery + '"' + checkCom + '>' + distt + '</option>';
        });
        $('[data-district]').html(homeDistrict);
        $('[data-district]').trigger('change');

        if (thisShipType == 'pickup') {
          if ($('[data-shipping-check]').attr('data-change_comuna') != 'true') {
            $('[data-stores]').removeClass('d-none');
            $('[data-shipping-check]').addClass('button-hidden');
          }
        } else {
          $('[data-stores]').addClass('d-none');
          $('[data-shipping-check]').removeClass('button-hidden');
        }
      });

      $('[data-stores]').change(function () {
        if ($(this).val() != '') {
          $('[data-shipping-check]').removeClass('button-hidden');
          $('[data-store-update]').removeClass('button-hidden');
        } else {
          $('[data-shipping-check]').addClass('button-hidden');
          $('[data-store-update]').addClass('button-hidden');
        }
      });
    },
    _updateStore: function _updateStore(event) {
      var $this = $(event.currentTarget);
      var thisVarid = $this.siblings('[data-shipping-check]').attr('data-variantpop-id');

      var tempProperties = {};
      var thisItem = app.cart.items.find(function (item) {
        return parseInt(item.variant_id) === parseInt(thisVarid);
      });

      var line = 0;
      app.cart.items.forEach(function (item, index) {
        if (parseInt(item.id) == parseInt(thisVarid)) {
          line = index;
        }
      });

      var lineitem = line + 1;
      var data = {
        quantity: thisItem.quantity,
        line: lineitem,
        properties: ''
      };
      tempProperties = thisItem.properties;
      tempProperties['shipping_type'] = 'pickup';

      var locId = $('[data-stores]').val();
      var storeName = $('[data-stores] option[value="' + locId + '"]').attr('data-store');

      tempProperties['shipping_store'] = storeName;
      tempProperties['shipping_storeid'] = locId;
      // tempProperties['delivery_available'] = 'true';
      tempProperties['pick_available'] = 'true';

      var dayINeed = 5; // for Friday
      var dayToday = moment().isoWeekday();

      if (dayToday <= dayINeed) {
        var dateConvert = moment().add(1, 'days');
      } else {
        var dateConvert = moment().add(3, 'days');
      }
      var tomorrowdate = [dateConvert.format('YYYY'), dateConvert.format('MM'), dateConvert.format('DD')].join('-');

      tempProperties['delivery_date'] = tomorrowdate;
      tempProperties['pickup_date'] = tomorrowdate;
      tempProperties['fulfillment_date'] = tomorrowdate;
      tempProperties['shipping_price'] = '';

      data.properties = tempProperties;

      jQuery.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        data: data
      }).done(function (rep) {
        app._getCartData();
        $('.border-month').removeAttr('data-popvarid');
        // $('#modalDate').modal('hide');
        $('#modalForShipping').modal('hide');
        $('#ship-address,#ship-address-noa,#address2,#address2-noa,[data-regions],[data-district]').removeClass('d-none');

        $('[data-shipping-check]').removeClass('d-none');
        $('[data-store-update]').addClass('d-none');

        $('#modalForShipping .modal-header').addClass('d-none').removeClass('pb-0');
        $('#modalForShipping .modal-header #exampleModalLongTitle').addClass('d-none');
        $('#modalForShipping .modal-body #exampleModalLongTitle').removeClass('d-none');

        if ($('[data-shipping-check]').attr('data-shipp_type') == 'pickup') {
          $('#modalForShipping').addClass('showtoggle').removeClass('showpopup');
          $('#modalForShipping .modal-dialog').addClass('m-0').removeClass('modal-dialog-centered modal-sm');
          $('#app').addClass('showtoggle').removeClass('showpopup');
        }
      });
      $('[data-shipping-check]').removeAttr('data-change_comuna');
      $('[data-shipping-check]').removeAttr('data-change_shipping_type');
    },
    _openCartDateModal: function _openCartDateModal(event) {
      $(event.currentTarget).css('pointer-events', 'none');
      var $this = $(event.currentTarget);
      var array = [];

      var thisVarid = $this.attr('data-variantpop-id');
      var change_shipping_type = $this.attr('data-change_shipping_type');
      var change_comuna = $this.attr('data-change_comuna');

      if (change_comuna != 'true') {
        var thisItem = app.cart.items.find(function (item) {
          return parseInt(item.variant_id) === parseInt(thisVarid);
        });
        array.push(thisItem);

        if ($this.attr('data-shipp_type') != '') {
          var shipping_type = $this.attr('data-shipp_type');
        } else {
          var shipping_type = thisItem.properties.shipping_type;
        }
        var shipping_date = thisItem.properties.delivery_date;

        var contains = { items: array };

        if (shipping_type == 'pickup') {
          if ($('[data-stores]').val() != '') {
            var location_id = $('[data-stores]').val();
          } else {
            var location_id = thisItem.properties.shipping_storeid;
          }
        } else {
          var location_id = 'null';
        }

        if (app.selectedRegion != null) {
          var valReg = app.selectedRegion;
        } else {
          if (app.cart.attributes != undefined) {
            if (app.cart.attributes["Region"] && app.cart.attributes["Region"] != '') {
              var valReg = app.cart.attributes["Region"];
            } else if ($('[data-regions]').val() != '' && $('[data-regions]').val() != null) {
              var valReg = $('[data-regions]').val();
            } else if (app._getCookie('selCommonR') != undefined && app._getCookie('selCommonR') != '' && app._getCookie('selCommonR') != 'selCommonR') {
              var valReg = app._getCookie('selCommonR');
            } else {
              var valReg = '';
            }
          } else if ($('[data-regions]').val() != '' && $('[data-regions]').val() != null) {
            var valReg = $('[data-regions]').val();
          } else if (app._getCookie('selCommonR') != undefined && app._getCookie('selCommonR') != '' && app._getCookie('selCommonR') != 'selCommonR') {
            var valReg = app._getCookie('selCommonR');
          } else {
            var valReg = '';
          }
        }

        if (app.selectedComuna != null) {
          var valCom = app.selectedComuna;
        } else {
          if (app.cart.attributes != undefined) {
            if (app.cart.attributes["Comuna"] && app.cart.attributes["Comuna"] != '') {
              var valCom = app.cart.attributes["Comuna"];
            } else if ($('[data-district]').val() != '' && $('[data-district]').val() != null) {
              var valCom = $('[data-district]').val();
            } else if (app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '' && app._getCookie('selCommonC') != 'selCommonC') {
              var valCom = app._getCookie('selCommonC');
            } else {
              var valCom = '';
            }
          } else if ($('[data-district]').val() != '' && $('[data-district]').val() != null) {
            var valCom = $('[data-district]').val();
          } else if (app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '' && app._getCookie('selCommonC') != 'selCommonC') {
            var valCom = app._getCookie('selCommonC');
          } else {
            var valCom = '';
          }
        }

        if (valReg && valReg != '' && valReg != null && valReg != undefined && valCom && valCom != '' && valCom != null && valCom != undefined) {
          var dataConfigL = {
            location_id: location_id,
            shipping_type: shipping_type,
            region: valReg,
            district: valCom,
            cart: JSON.stringify(contains),
            date_count: 10,
            change_shipping_type: change_shipping_type
          };

          if (app.freeShippingEnabled) {
            var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
          } else {
            var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
          }

          $.ajax({
            type: 'POST',
            url: ajax_url,
            dataType: 'json',
            data: dataConfigL,
            beforeSend: function beforeSend() {
              $this.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
            },
            success: function success(data) {
              $('[data-shipping-check]').removeAttr('style');
              if (data.errors) {
                setTimeout(function () {
                  location.reload();
                }, 2500);
                return false;
              }

              document.cookie = 'selCommonC=' + valCom + ';path=/' + ';';
              document.cookie = 'selCommonR=' + valReg + ';path=/' + ';';

              $.post('/cart.js', {
                attributes: {
                  'Region': valReg,
                  'Comuna': valCom
                }
              }).done(function () {});

              if ($this.attr('data-text') == 'Cambiar fecha') {
                $this.html($this.attr('data-text'));
              }
              $('#modalForShipping').modal('hide');
              $('[data-shipping-check]').addClass('button-hidden');
              $('[data-shipping-check]').html('Seleccionar');

              var check24hdel = 0;

              data.forEach(function (item, index) {

                if (item.allow_24H_delivery == true) {
                  check24hdel = 1;
                }

                if (shipping_type == 'marketplace') {} else {

                  if (shipping_type == 'pickup') {
                    var ship_pick_dates = item.pickup_dates;
                  } else {
                    var ship_pick_dates = item.shipping_dates;
                  }

                  var dileveryDate = [];
                  var fulfilDate = [];
                  var getMonth = '';
                  var firstDate = '';

                  var count = 0;
                  $.each(ship_pick_dates, function (shipping_date) {
                    count = count + 1;
                    if (count == 1) {
                      getMonth = shipping_date;
                    }
                    if (count < 11) {
                      firstDate = shipping_date;
                      fulfilDate.push(ship_pick_dates[shipping_date].fulfilment_date);
                      dileveryDate.push(shipping_date);
                    }
                  });
                  getMonth = getMonth.split('-')[1];
                  setTimeout(function () {
                    $this.parents('[data-cart-item]').find('.datepicker-cart').show();
                    var calendar = $this.parents('[data-cart-item]').find(".flatpickr").flatpickr({
                      inline: true,
                      altFormat: "l F J, Y",
                      altInput: false,
                      dateFormat: "Y-m-d",
                      enable: dileveryDate,
                      defaultDate: [shipping_date],
                      locale: {
                        firstDayOfWeek: 1, // start week on Monday
                        weekdays: {
                          shorthand: ['dom', 'lun', 'mar', 'miér', 'jue', 'vier', 'sáb'],
                          longhand: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
                        },
                        months: {
                          shorthand: ['ene', 'feb', 'mar', 'abr', 'may', 'juni', 'juli', 'ago', 'sept', 'oct', 'nov', 'dic'],
                          longhand: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
                        }
                      },
                      onChange: function onChange(selectedDates, dateStr, instance) {
                        $(instance.calendarContainer).parents('[data-cart-item]').find('.datepicker-cart').show();
                        $.each(ship_pick_dates, function (shipping_date) {
                          if (shipping_date == dateStr) {}
                        });
                        var dateConvert = moment(dateStr);
                        dateConvert.locale('es');
                        var date1 = dateConvert.format('dddd');
                        var date2 = dateConvert.format('D');
                        var date3 = dateConvert.format('MMMM');
                        var date4 = dateConvert.format('YYYY');
                        var date = date1 + ', ' + date2 + ' de ' + date3 + ', ' + date4;

                        var tempProperties = {};
                        var thisVarid = $(instance.calendarContainer).parents('[data-cart-item]').attr('data-variant-id');
                        var thisItem = app.cart.items.find(function (item) {
                          return parseInt(item.variant_id) === parseInt(thisVarid);
                        });

                        var line = 0;
                        app.cart.items.forEach(function (item, index) {
                          if (parseInt(item.id) == parseInt(thisVarid)) {
                            line = index;
                          }
                        });

                        var lineitem = line + 1;
                        var dataConfig = {
                          quantity: thisItem.quantity,
                          line: lineitem,
                          properties: ''
                        };

                        tempProperties = thisItem.properties;
                        tempProperties['shipping_type'] = shipping_type;
                        tempProperties['delivery_date'] = dateStr;
                        tempProperties['fulfillment_date'] = ship_pick_dates[dateStr].fulfilment_date;
                        tempProperties['pickup_date'] = '';

                        if (shipping_type == 'pickup') {
                          var locId = $('[data-stores]').val();
                          var storeName = $('[data-stores] option[value="' + locId + '"]').attr('data-store');

                          tempProperties['shipping_store'] = storeName;
                          tempProperties['shipping_storeid'] = locId;

                          tempProperties['pick_available'] = item.pick_available;
                        } else if (shipping_type == 'preorder') {} else if (shipping_type == 'marketplace') {} else {
                          tempProperties['shipping_store'] = '';
                          tempProperties['shipping_storeid'] = '';
                          tempProperties['pick_available'] = item.pick_available;
                        }

                        dataConfig.properties = tempProperties;

                        jQuery.ajax({
                          url: '/cart/change.js',
                          dataType: 'json',
                          data: dataConfig
                        }).done(function (rep) {
                          app._getCartData();
                          $('.border-month').removeAttr('data-popvarid');
                          $(instance.calendarContainer).parents('[data-cart-item]').find('.datepicker-cart').siblings('a').removeAttr('style');
                        });

                        $('[data-shipping-check]').removeAttr('data-change_comuna');
                        $('[data-shipping-check]').removeAttr('data-change_shipping_type');

                        $(instance.calendarContainer).parents('[data-cart-item]').find('.datepicker-cart').removeClass('d-none');
                      }
                    });
                    $(".datepicker-cart").click(function (e) {
                      e.stopPropagation(); // This is the preferred method.
                      return false; // This should not be used unless you do not want
                    });
                  }, 800);

                  return false;
                }
                $('input.shipp_price_prop').val(item.shipping_price);
                $('input.shipp_type').val(shipping_type);
              });

              if (check24hdel != 0) {
                localStorage.setItem('allow24hDelBlk', 'true');
              } else {
                if (data.length > 1) {
                  localStorage.removeItem('allow24hDelBlk');
                }
              }
            },
            error: function error(err) {
              if (err.responseJSON.errors) {
                var title = 'Mensaje de error';
                var body = 'Complete todos los datos';
                app.$snotify.error(body, title, {
                  timeout: 3000,
                  showProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  titleMaxLength: 80,
                  icon: 'https://cdn.shopify.com/s/files/1/0104/4391/5319/files/danger.png?v=1624358532',
                  buttons: [{
                    text: 'Cerrar',
                    bold: true,
                    closeOnClick: true
                  }]
                });
                setTimeout(function () {
                  location.reload();
                }, 2500);
                return false;
              }
            }
          });
        }
      }

      if ($('[data-shipping-check]').attr('data-change_comuna') == 'true' || $('[data-shipping-check]').attr('data-change_comuna') == true) {

        var _change_shipping_type = $('[data-shipping-check]').attr('data-change_shipping_type');
        var checkInstPrd = [];
        var checkInstGrillTyp = [];
        app.cart.items.forEach(function (item, index) {
          if (item.product_type == 'Warranty' || item.product_type == 'Installation' || item.product_type == 'Grill assembly') {
            $.ajax({
              type: "GET",
              async: false,
              url: '/products/' + item.handle + '?view=json',
              dataType: "json",
              success: function success(data) {
                if (data.product.tags == '') {
                  item.properties.tags = '';
                } else {
                  item.properties.tags = data.product.tags.toString();
                }
              }
            });
          }
          if (item.product_type == 'Installation' || item.product_type == 'Grill assembly') {
            checkInstPrd.push(item.id);
            checkInstGrillTyp.push(item.product_type);
          }
        });

        // let thisItem = app.cart.items.find((item) => parseInt(item.variant_id) === parseInt(thisVarid));

        var tempArray = app.cart.items;
        tempArray.forEach(function (item, index) {

          for (var subitem in item) {
            if (subitem != 'id' && subitem != 'properties' && subitem != 'quantity' && subitem != 'variant_id' && subitem != 'vendor' && subitem != 'requires_shipping' && subitem != 'product_type') {
              delete item[subitem];
            }
          }
        });

        array = tempArray;

        if ($this.attr('data-shipp_type') != '') {
          var shipping_type = $this.attr('data-shipp_type');
        }

        var _contains = { items: array };

        var location_id = 'null';
        if ($('.show-autocon').length > 0) {
          var valReg = $('.show-autocon [data-regions]').val();
          var valCom = $('.show-autocon [data-district]').val();
        } else if ($('#modalForShippingHomeCol').length > 0) {
          var valReg = $('#modalForShippingHomeCol [data-regions]').val();
          var valCom = $('#modalForShippingHomeCol [data-district]').val();
        }

        var address1 = $('.show-autocon [name="ship-addr"]').val();
        var address2 = $('.show-autocon [name="addrr2"]').val();

        if (valReg != null && valReg != '') {
          document.cookie = 'selectedRegion=' + valReg + ';path=/' + ';';
          // app.selectedRegion = valReg;
        }
        if (valCom != null && valCom != '') {
          document.cookie = 'selectedComuna=' + valCom + ';path=/' + ';';
          // app.selectedComuna = valCom;

          document.cookie = 'selCommonC=' + valCom + ';path=/' + ';';
          document.cookie = 'selCommonR=' + valReg + ';path=/' + ';';

          $.post('/cart.js', {
            attributes: {
              'Region': valReg,
              'Comuna': valCom
            }
          }).done(function () {});
        }

        document.cookie = 'selectedaddress1=' + address1 + ';path=/' + ';';
        document.cookie = 'selectedaddress2=' + address2 + ';path=/' + ';';

        document.cookie = 'selectedTimestamp=' + new Date().getTime() + ';path=/' + ';'; //'2021-10-27'

        if (navigator.userAgent.toLowerCase().indexOf('safari') > -1) {
          localStorage.setItem('selectedaddress1', address1);
        }

        if ($('.show-autocon #checkout_verify_address').prop('checked') == true && $('.show-autocon .checkbox-wrapper').is(':visible')) {
          document.cookie = 'selectedAddVerified=1;path=/' + ';';
        } else {
          document.cookie = 'selectedAddVerified=0;path=/' + ';';
        }

        if (valReg && valReg != '' && valReg != null && valReg != undefined && valCom && valCom != '' && valCom != null && valCom != undefined) {
          var dataConfigN = {
            location_id: location_id,
            shipping_type: shipping_type,
            region: valReg,
            district: valCom,
            cart: JSON.stringify(_contains),
            date_count: 1,
            change_shipping_type: _change_shipping_type,
            change_comuna: 1
          };

          if (app.freeShippingEnabled) {
            var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
          } else {
            var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
          }

          $.ajax({
            type: 'POST',
            url: ajax_url,
            dataType: 'json',
            data: dataConfigN,
            beforeSend: function beforeSend() {
              $('[data-shipping-check]').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
            },
            success: function success(data) {
              if (data.errors) {
                setTimeout(function () {
                  location.reload();
                }, 2500);
                return false;
              }
              var setTimeFinal = 0;
              var check24hdel = 0;

              data.forEach(function (item, index) {
                var shipping_type = item.type;
                var tempProperties = {};
                var thisVarid = item.id;
                var thisItem = app.cart.items.find(function (item) {
                  return parseInt(item.variant_id) === parseInt(thisVarid);
                });

                if (item.allow_24H_delivery == true) {
                  check24hdel = 1;
                }

                var line = 0;
                app.cart.items.forEach(function (item, index) {
                  if (parseInt(item.id) == parseInt(thisVarid)) {
                    line = index;
                  }
                });

                var lineitem = line + 1;
                var dataConfig2 = {
                  quantity: thisItem.quantity,
                  line: lineitem,
                  properties: ''
                };

                tempProperties = thisItem.properties;

                // if(thisItem.product_type != 'Installation'){
                tempProperties['shipping_type'] = item.type;
                if (shipping_type == 'preorder') {
                  tempProperties['shipping_price'] = item.shipping_price;
                  tempProperties['delivery_date'] = item.start_date;
                  tempProperties['range_date'] = item.start_date + ' - ' + item.end_date;
                  tempProperties['fulfillment_date'] = item.fulfillment_date;
                } else if (shipping_type == 'marketplace') {
                  tempProperties['shipping_price'] = item.shipping_price;
                  tempProperties['delivery_date'] = item.delivery_date;
                  tempProperties['range_date'] = item.start_date + ' - ' + item.end_date;
                  tempProperties['fulfillment_date'] = item.fulfillment_date;
                } else {
                  if (shipping_type == 'pickup') {
                    var ship_pick_dates = item.pickup_dates;
                    var selShipdateArray = $.map(ship_pick_dates, function (element, index) {
                      return index;
                    });
                    var selShipdate = selShipdateArray.toString();
                  } else {
                    var ship_pick_dates = item.shipping_dates;
                    var selShipdateArray = $.map(ship_pick_dates, function (element, index) {
                      return index;
                    });
                    var selShipdate = selShipdateArray.toString();
                    var selFullfilldate = ship_pick_dates[selShipdate].fulfilment_date;
                  }

                  tempProperties['delivery_date'] = selShipdate;
                  tempProperties['pickup_date'] = '';

                  if (shipping_type == 'pickup') {
                    tempProperties['shipping_price'] = '';
                    tempProperties['pick_available'] = item.pick_available;
                  } else if (shipping_type == 'preorder') {} else if (shipping_type == 'marketplace') {} else {
                    tempProperties['shipping_price'] = item.shipping_price;
                    tempProperties['fulfillment_date'] = selFullfilldate;

                    tempProperties['pick_available'] = item.pick_available;

                    tempProperties['shipping_store'] = '';
                    tempProperties['shipping_storeid'] = '';
                  }
                }
                // }

                dataConfig2.properties = tempProperties;

                var setTime = index * 500;
                setTimeFinal = index * 500 + 300;
                setTimeout(function () {
                  jQuery.ajax({
                    url: '/cart/change.js',
                    dataType: 'json',
                    data: dataConfig2
                  }).done(function (rep) {});
                }, setTime);
              });

              if (check24hdel != 0) {
                localStorage.setItem('allow24hDelBlk', 'true');
              } else {
                if (data.length > 1) {
                  localStorage.removeItem('allow24hDelBlk');
                }
              }

              setTimeout(function () {
                app.selectedRegion = valReg;
                app.selectedComuna = valCom;

                app.checkInstGrillTyp = checkInstGrillTyp;

                if (valReg != 'Región Metropolitana' && checkInstPrd.length > 0) {
                  $('#modalWarningInsPrd').modal('show');
                  if ($('.modal-backdrop').length == 2) {
                    $('.modal-backdrop').addClass('must-show');
                  }
                  $('#app').addClass('show-ins-overlay');
                  var $prodQTY = [];
                  $(app.cart.items).each(function (index, item) {
                    var varId = item.id;
                    var varQty = item.quantity;
                    if ($.inArray(varId, checkInstPrd) >= 0) {
                      varQty = 0;
                    }
                    $prodQTY.push(varQty);
                  });

                  axios.post('/cart/update.js', {
                    updates: $prodQTY
                  }).then(function (response) {
                    app.isLoading = false;
                    app._getCartData();
                  });
                } else {
                  app._getCartData();
                }
              }, setTimeFinal);
              setTimeout(function () {
                $('.msg-reg-com').addClass('d-none');
                $('#modalForShipping').modal('hide');
                $('[data-shipping-check]').addClass('button-hidden');
                $('[data-shipping-check]').html('Seleccionar');
                $('[data-shipping-check]').removeAttr('data-change_comuna');
                $('[data-shipping-check]').removeAttr('data-change_shipping_type');

                // if($("#modalForShippingHomeCol").hasClass('show')){	
                $("[data-store-all]").addClass("button-hidden");
                $("#modalForShippingHomeCol [data-district]").html('<option value="" disabled selected>Selecciona tu Comuna</option>');
                $("#modalForShippingHomeCol").modal("hide");
                $('[data-store-all]').html('Seleccionar');
                $("#modalForShippingHomeCol .close").show();
                $('#app').addClass('showtoggle').removeClass('showpopup');
                $(".template-cart .mp-loader").remove();
                // }

                app.selectedRegion = valReg;
                app.selectedComuna = valCom;
              }, setTimeFinal + 300);
            },
            error: function error(err) {
              if (err.responseJSON.errors) {
                var title = 'Mensaje de error';
                var body = 'Complete todos los datos';
                app.$snotify.error(body, title, {
                  timeout: 3000,
                  showProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  titleMaxLength: 80,
                  icon: 'https://cdn.shopify.com/s/files/1/0104/4391/5319/files/danger.png?v=1624358532',
                  buttons: [{
                    text: 'Cerrar',
                    bold: true,
                    closeOnClick: true
                  }]
                });
                setTimeout(function () {
                  location.reload();
                }, 2500);
                return false;
              }
            }
          });
        }
      }
    },
    _changeComuna: function _changeComuna(event) {

      var $this = $(event.currentTarget);
      var array = [];

      $('[data-shipping-check]').removeAttr('style');
      $('[data-shipping-check]').attr('data-change_comuna', true);
      $('[data-shipping-check]').attr('data-shipp_type', 'delivery');
      $('[data-shipping-check]').attr('data-change_shipping_type', '0');

      $('#ship-address,#ship-address-noa,#address2,#address2-noa,[data-regions],[data-district]').removeClass('d-none');
      $('[data-stores]').addClass('d-none');

      $('[data-shipping-check]').removeClass('d-none');
      $('[data-store-update]').addClass('d-none');
      $('#modalForShipping .modal-header').addClass('d-none').removeClass('pb-0');
      $('#modalForShipping .modal-header #exampleModalLongTitle').addClass('d-none');
      $('#modalForShipping .modal-body #exampleModalLongTitle').removeClass('d-none');

      if (app._getCookie('selectedaddress1') != undefined && app._getCookie('selectedaddress1') != '' && app._getCookie('selectedaddress1') != 'selectedaddress1') {
        $('#ship-address, #ship-address-noa').val(app._getCookie('selectedaddress1')).trigger('change');
        $('#address2, #address2-noa').val(app._getCookie('selectedaddress2')).trigger('change');
        if (app._getCookie('selectedAddVerified') == 1) {
          $('.div-autocomp').removeClass('show-autocon').hide();
          $('.div-none-autocomp').addClass('show-autocon').show();
          $('.back-direction').addClass('show');
          $('.no-direction').removeClass('show');
          if (!$('.show-autocon .checkbox-wrapper').is(':visible')) {
            $('.show-autocon .checkbox-wrapper').removeClass('d-none');
            $('.show-autocon .checkbox-wrapper #checkout_verify_address').prop("checked", true).trigger("change");
            $('[data-regions] , [data-district]').removeAttr('disabled');
            $('[data-shipping-check]').removeClass('button-hidden'); //can remove if needed
          }
        } else {
          $('.div-none-autocomp').removeClass('show-autocon').hide();
          $('.div-autocomp').addClass('show-autocon').show();
          $('.no-direction').addClass('show');
          $('.back-direction').removeClass('show');
          $('[data-regions], [data-district]').attr('disabled', 'disabled');
        }

        // $('#app').addClass('showtoggle');
        // if($('[data-shipping-check]').attr('data-shipp_type') == 'pickup'){
        $('#modalForShipping').addClass('showtoggle').removeClass('showpopup');
        $('#modalForShipping .modal-dialog').addClass('m-0').removeClass('modal-dialog-centered modal-sm');
        $('#app').addClass('showtoggle').removeClass('showpopup');
        // }
      }
      // $('[data-regions] , [data-district]').removeAttr('disabled');

      var regionsJson = void 0;

      var regionsLocalStrg = localStorage.getItem('regionsJsonLS');
      if (regionsLocalStrg && regionsLocalStrg != '' && regionsLocalStrg != undefined) {
        var regions = JSON.parse(regionsLocalStrg);
        regionsJson = regions;
        var homeRegion = '<option disabled selected value="">Región</option>';
        var count = 0;
        var checkReg = '';
        $.each(regions, function () {
          $.each(this, function (k, value) {
            if (value.region != 'Regi') {
              if (value.region != 'Portugal') {
                if (app.selectedRegion != null && app.selectedRegion != '' && app.selectedRegion == value.region) {
                  checkReg = ' selected="selected"';
                } else {
                  checkReg = '';
                }
                if (count == 0) {
                  // homeRegion += '<option value="'+value.region+'"'+checkReg+'>'+value.region+'</option>';
                  homeRegion += '<option value="' + value.region + '" data-shortvalue="' + value.region.replace('Región de ', '').replace('Región del ', '').replace('Región ', '').toLowerCase() + '"' + checkReg + '>' + value.region + '</option>';
                } else {
                  if (homeRegion.indexOf(value.region) == -1) {
                    // homeRegion += '<option value="'+value.region+'"'+checkReg+'>'+value.region+'</option>';
                    homeRegion += '<option value="' + value.region + '" data-shortvalue="' + value.region.replace('Región de ', '').replace('Región del ', '').replace('Región ', '').toLowerCase() + '"' + checkReg + '>' + value.region + '</option>';
                  }
                }
              }
            }
            count++;
          });
        });
        $('[data-regions]').html(homeRegion);
        setTimeout(function () {
          $('[data-regions]').trigger('change');
        }, 400);
        $('[data-stores]').addClass('d-none');
        $('#modalForShipping').modal('show');
      } else {
        $.ajax({
          type: 'GET',
          url: 'https://app.kitchencenter.cl/api/calendar/regions',
          success: function success(regions) {
            regionsJson = regions;
            var homeRegion = '<option disabled selected value="">Región</option>';
            var count = 0;
            var checkReg = '';
            $.each(regions, function () {
              $.each(this, function (k, value) {
                if (value.region != 'Regi') {
                  if (value.region != 'Portugal') {
                    if (app.selectedRegion != null && app.selectedRegion != '' && app.selectedRegion == value.region) {
                      checkReg = ' selected="selected"';
                    } else {
                      checkReg = '';
                    }
                    if (count == 0) {
                      // homeRegion += '<option value="'+value.region+'"'+checkReg+'>'+value.region+'</option>';
                      homeRegion += '<option value="' + value.region + '" data-shortvalue="' + value.region.replace('Región de ', '').replace('Región del ', '').replace('Región ', '').toLowerCase() + '"' + checkReg + '>' + value.region + '</option>';
                    } else {
                      if (homeRegion.indexOf(value.region) == -1) {
                        // homeRegion += '<option value="'+value.region+'"'+checkReg+'>'+value.region+'</option>';
                        homeRegion += '<option value="' + value.region + '" data-shortvalue="' + value.region.replace('Región de ', '').replace('Región del ', '').replace('Región ', '').toLowerCase() + '"' + checkReg + '>' + value.region + '</option>';
                      }
                    }
                  }
                }
                count++;
              });
            });
            $('[data-regions]').html(homeRegion);
            $('[data-regions]').trigger('change');
            $('[data-stores]').addClass('d-none');
            $('#modalForShipping').modal('show');
          },
          error: function error(res) {
            console.log(res);
          }
        });
      }

      $('[data-regions]').change(function () {
        var val = $(this).val();
        var homeDistrict = '<option value="" disabled selected>Comuna</option>';
        var checkCom = '';
        $.each(regionsJson[val], function (k, value) {
          var disttorg = value.district;
          var distt = value.district;
          distt = distt.replace(/í/g, 'i');
          distt = distt.replace(/á/g, 'a');
          if (app.selectedComuna != null && app.selectedComuna != '' && (app.selectedComuna == disttorg || app.selectedComuna == disttorg)) {
            checkCom = ' selected="selected"';
          } else {
            checkCom = '';
          }
          homeDistrict += '<option value="' + disttorg + '" data-value="' + distt + '" data-out="' + value.is_out_of_delivery + '"' + checkCom + '>' + distt + '</option>';
        });
        $('[data-district]').html(homeDistrict);
        $('[data-district]').trigger('change');

        // if($(this).val() != app.selectedRegion){
        //   $('[data-shipping-check]').removeClass('button-hidden');
        // }
        // else{
        //   $('[data-shipping-check]').addClass('button-hidden');
        // }
      });

      $('[data-district]').change(function () {
        // if($(this).val() != app.selectedComuna){
        if ($(this).val() != '' && $(this).val() != null && $('.show-autocon [name="ship-addr"]').val() != '') {
          $('[data-shipping-check]').removeClass('button-hidden');
          if ($('.show-autocon #checkout_verify_address').prop('checked') == true && $('.show-autocon .checkbox-wrapper').is(':visible') && $('.show-autocon .numeric_error').is(':visible') == false && $('.show-autocon .numeric_only_error').is(':visible') == false) {
            $('.button-overlay').addClass('d-none');
          }
        } else {
          $('[data-shipping-check]').addClass('button-hidden');
        }
      });

      $('#ship-address-noa').blur(function () {
        if ($(this).val() == '') {
          $('[data-shipping-check]').addClass('button-hidden');
          $('.show-autocon .checkbox-wrapper label').remove('checkbox_error');
        } else {
          if (!/\d/.test($('#ship-address-noa').val())) {
            $('.show-autocon .numeric_error').removeClass('d-none');
            $('.show-autocon .numeric_only_error').addClass('d-none');
            $('.show-autocon .addlength_error').addClass('d-none');
            $('#ship-address-noa').addClass('input-error');
          } else {
            $('.show-autocon .numeric_error').addClass('d-none');
            $('.show-autocon .numeric_only_error').addClass('d-none');

            if ($('#ship-address-noa').val().length < 6) {
              $('.show-autocon .addlength_error').removeClass('d-none');
              $('#ship-address-noa').addClass('input-error');
            } else {
              $('.show-autocon .addlength_error').addClass('d-none');
              $('#ship-address-noa').removeClass('input-error');
            }
          }

          if ($('.show-autocon #checkout_verify_address').prop('checked') == true && $('.show-autocon .checkbox-wrapper').is(':visible') && $('.show-autocon .numeric_error').is(':visible') == false && $('.show-autocon .numeric_only_error').is(':visible') == false) {
            $('[data-shipping-check]').removeClass('button-hidden');
            $('.button-overlay').addClass('d-none');
          } else {
            $('.show-autocon .checkbox-wrapper label').remove('checkbox_error');

            $('[data-shipping-check]').addClass('button-hidden');

            $('.show-autocon .checkbox-wrapper').removeClass('d-none');
            $('.button-overlay').removeClass('d-none');
            $('[data-regions], [data-district]').removeAttr('disabled', 'disabled');
          }
        }
      });

      $('#modalDate .close, #modalForShipping .close, #modalForShippingHomeCol .close').click(function () {
        $('[data-shipping-check]').removeAttr('data-change_comuna');
        $('[data-shipping-check]').removeAttr('data-change_shipping_type');
      });
    },
    _checkComunaOnLoad: function _checkComunaOnLoad(event) {
      var array = [];
      if (app._getCookie('selectedaddress1') != undefined && app._getCookie('selectedaddress1') != '' && app._getCookie('selectedaddress1') != 'selectedaddress1') {

        $('#app').addClass('showtoggle');
        $('.msg-reg-com').addClass('d-none');

        if (app._getCookie('selCommonC') && app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '') {
          if (app._getCookie('selCommonC') == app._getCookie('selectedComuna')) {
            app._getCartData();
            return false;
          }
        } else {
          if (app.cart.attributes["Region"] && app.cart.attributes["Region"] != '' && app.cart.attributes["Comuna"] && app.cart.attributes["Comuna"] != '') {
            app._getCartData();
            return false;
          }
        }
        var change_shipping_type = 0;

        var tempArray = app.cart.items;
        var updateItem = [];
        tempArray.forEach(function (item, index) {
          if (item.properties.product_type != 'warranty') {
            for (var subitem in item) {
              if (subitem != 'id' && subitem != 'properties' && subitem != 'quantity' && subitem != 'variant_id' && subitem != 'vendor' && subitem != 'requires_shipping' && subitem != 'product_type') {
                delete item[subitem];
              }
            }
            updateItem.push(item);
          }
        });

        array = updateItem;

        var shipping_type = "delivery";

        if (array.length > 0) {
          var contains = { items: array };

          var location_id = 'null';
          if (app.cart.attributes != undefined) {
            if (app.cart.attributes["Region"] && app.cart.attributes["Region"] != '') {
              var valReg = app.cart.attributes["Region"];
            } else {
              if (app._getCookie('selCommonR') != undefined && app._getCookie('selCommonR') != '' && app._getCookie('selCommonR') != 'selCommonR') {
                var valReg = app._getCookie('selCommonR');
              } else {
                var valReg = '';
              }
            }
          } else {
            if (app._getCookie('selCommonR') != undefined && app._getCookie('selCommonR') != '' && app._getCookie('selCommonR') != 'selCommonR') {
              var valReg = app._getCookie('selCommonR');
            } else {
              var valReg = '';
            }
          }

          if (app.cart.attributes != undefined) {
            if (app.cart.attributes["Comuna"] && app.cart.attributes["Comuna"] != '') {
              var valCom = app.cart.attributes["Comuna"];
            } else {
              if (app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '' && app._getCookie('selCommonC') != 'selCommonC') {
                var valCom = app._getCookie('selCommonC');
              } else {
                var valCom = '';
              }
            }
          } else {
            if (app._getCookie('selCommonC') != undefined && app._getCookie('selCommonC') != '' && app._getCookie('selCommonC') != 'selCommonC') {
              var valCom = app._getCookie('selCommonC');
            } else {
              var valCom = '';
            }
          }

          if (valReg && valReg != '' && valReg != null && valReg != undefined && valCom && valCom != '' && valCom != null && valCom != undefined) {
            var dataConfig = {
              location_id: location_id,
              shipping_type: shipping_type,
              region: valReg,
              district: valCom,
              cart: JSON.stringify(contains),
              date_count: 1,
              change_shipping_type: change_shipping_type,
              change_comuna: 1
            };

            if (app.freeShippingEnabled) {
              var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new-free';
            } else {
              var ajax_url = 'https://app.kitchencenter.cl/api/calendar/shipping-new';
            }
            $.ajax({
              type: 'POST',
              url: ajax_url,
              dataType: 'json',
              data: dataConfig,
              beforeSend: function beforeSend() {
                // $('[data-shipping-check]').html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
              },
              success: function success(data) {
                if (data.errors) {
                  setTimeout(function () {
                    location.reload();
                  }, 2500);
                  return false;
                }
                data.forEach(function (item, index) {
                  var shipping_type = item.type;
                  var tempProperties = {};
                  var thisVarid = item.id;
                  var thisItem = app.cart.items.find(function (item) {
                    return parseInt(item.variant_id) === parseInt(thisVarid);
                  });

                  var line = 0;
                  app.cart.items.forEach(function (item, index) {
                    if (parseInt(item.id) == parseInt(thisVarid)) {
                      line = index;
                    }
                  });

                  var lineitem = line + 1;
                  var data = {
                    quantity: thisItem.quantity,
                    line: lineitem,
                    properties: ''
                  };

                  tempProperties = thisItem.properties;

                  tempProperties['shipping_type'] = item.type;
                  if (shipping_type == 'preorder') {
                    tempProperties['shipping_price'] = item.shipping_price;
                    tempProperties['delivery_date'] = item.start_date; //item.end_date
                    tempProperties['range_date'] = item.start_date + ' - ' + item.end_date;
                    tempProperties['fulfillment_date'] = item.fulfillment_date; //item.start_date
                  } else if (shipping_type == 'marketplace') {
                    tempProperties['shipping_price'] = item.shipping_price;
                    tempProperties['delivery_date'] = item.delivery_date;
                    tempProperties['range_date'] = item.start_date + ' - ' + item.end_date;
                    tempProperties['fulfillment_date'] = item.fulfillment_date;
                  } else {
                    if (shipping_type == 'pickup') {
                      var ship_pick_dates = item.pickup_dates;
                      var selShipdateArray = $.map(ship_pick_dates, function (element, index) {
                        return index;
                      });
                      var selShipdate = selShipdateArray.toString();
                    } else {
                      var ship_pick_dates = item.shipping_dates;
                      var selShipdateArray = $.map(ship_pick_dates, function (element, index) {
                        return index;
                      });
                      var selShipdate = selShipdateArray.toString();
                      var selFullfilldate = ship_pick_dates[selShipdate].fulfilment_date;
                    }

                    tempProperties['delivery_date'] = selShipdate;
                    tempProperties['pickup_date'] = '';

                    if (shipping_type == 'pickup') {
                      tempProperties['shipping_price'] = '';
                      tempProperties['pick_available'] = item.pick_available;
                    } else if (shipping_type == 'preorder') {} else if (shipping_type == 'marketplace') {} else {
                      tempProperties['shipping_price'] = item.shipping_price;
                      tempProperties['fulfillment_date'] = selFullfilldate;
                      tempProperties['pick_available'] = item.pick_available;
                      tempProperties['shipping_store'] = '';
                      tempProperties['shipping_storeid'] = '';
                    }
                  }

                  data.properties = tempProperties;

                  var setTime = index * 500;
                  setTimeout(function () {
                    jQuery.ajax({
                      url: '/cart/change.js',
                      dataType: 'json',
                      data: data
                    }).done(function (rep) {
                      app.selectedRegion = app._getCookie('selectedRegion');
                      app.selectedComuna = app._getCookie('selectedComuna');
                      app._getCartData();
                      $('.border-month').removeAttr('data-popvarid');
                      setTimeout(function () {
                        document.cookie = 'selCommonC=' + app.selectedComuna + ';path=/' + ';';
                        document.cookie = 'selCommonR=' + app.selectedRegion + ';path=/' + ';';
                      }, 2000);
                      $('[data-shipping-check]').addClass('button-hidden');
                      $('[data-shipping-check]').html('Seleccionar');
                    });
                  }, setTime);
                });
              },
              error: function error(err) {
                if (err.responseJSON.errors) {
                  var title = 'Mensaje de error';
                  var body = 'Complete todos los datos';
                  app.$snotify.error(body, title, {
                    timeout: 3000,
                    showProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    titleMaxLength: 80,
                    icon: 'https://cdn.shopify.com/s/files/1/0104/4391/5319/files/danger.png?v=1624358532',
                    buttons: [{
                      text: 'Cerrar',
                      bold: true,
                      closeOnClick: true
                    }]
                  });
                  setTimeout(function () {
                    location.reload();
                  }, 2500);
                  return false;
                }
              }
            });
          }
        }
      } else {
        // $('.check_com a')[0].click();
        setTimeout(function () {
          if (app._getCookie('selectedaddress1') != undefined && app._getCookie('selectedaddress1') != '' && app._getCookie('selectedaddress1') != 'selectedaddress1') {
            $('#ship-address, #ship-address-noa').val(app._getCookie('selectedaddress1')).trigger('change');
            $('#address2, #address2-noa').val(app._getCookie('selectedaddress2')).trigger('change');

            var dataRegCheck = app._getCookie('selectedRegion');
            $('[data-regions] option').each(function () {
              if (dataRegCheck.indexOf($(this).val()) > -1) {
                $('[data-regions]').val($(this).val()).trigger('change');
              }
            });

            var dataComCheck = app._getCookie('selectedComuna');
            $('[data-district] option').each(function () {
              if (dataComCheck.indexOf($(this).val()) > -1) {
                $('[data-district]').val($(this).val()).trigger('change');
              }
            });
          }
        }, 2000);
      }

      // });
    },
    _hideWarningPopup: function _hideWarningPopup(event) {
      $('#modalWarningInsPrd').modal('hide');
      $('.modal-backdrop').removeClass('must-show');
      $('#app').removeClass('show-ins-overlay');
    },
    _openComunaIns: function _openComunaIns(event) {
      $('.template-cart .selected-communa')[0].click();
    },
    _deleteWarranty: function _deleteWarranty(event) {
      var $this = $(event.currentTarget);
      $this.parents('.card').find('.collapse ul li.item_warranty_variants a[data-update-warr].d-block')[0].click();
    },
    _hideRebuyPopup: function _hideRebuyPopup(event) {
      var $this = $(event.currentTarget);
      $this.parents('.widget-display-popup').removeClass('is-visible').addClass('is-hidden');
    },
    _getParameterfromString: function _getParameterfromString(string, name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(string);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    _rebuyCartPageWidgetUpdate: function _rebuyCartPageWidgetUpdate() {
      if (app.currentTemplate == 'cart' && $('.rebuy-cart-recommended-products').length > 0) {

        setTimeout(function () {
          var openWidgetData1 = Rebuy.widgets[0].data.products;

          openWidgetData1.forEach(function (item, index) {
            if ($('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-vendor').length > 0) {
              $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-vendor').remove();
            }
            $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info').prepend('<p class="rebuy-vendor">' + item.vendor + '</p>');

            if ($('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-product-text-badges').length > 0) {
              $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-product-text-badges').remove();
            }
            var badge_val = '';
            var badge_color = '';
            if (item.tags.indexOf('badge_') > -1) {
              item.tags.split(', ').forEach(function (tag) {
                if (tag.match('badge_')) {
                  var badge_ = tag.replace('badge_', '');
                  var bagde_arr = badge_.split('_');
                  badge_val = bagde_arr[0];
                  badge_color = bagde_arr[1];
                }
              });
              $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info').prepend('<span class="rebuy-product-text-badges" style="background-color:' + badge_color + '">' + badge_val + '</span>');
            }

            if ($('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-product-offer-badges').length > 0) {
              $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info .rebuy-product-offer-badges').remove();
            }
            if (item.selected_variant.compare_at_price > item.selected_variant.price) {
              var discountPer = Math.ceil((item.selected_variant.price - item.selected_variant.compare_at_price) / item.selected_variant.compare_at_price * 100);
              // discountPer = korting.toString().replace('-', '');
              $('.rebuy-cart-recommended-products .rebuy-product-block.product-id-' + item.id + ' .rebuy-product-info').prepend('<span class="rebuy-product-offer-badges">' + discountPer + '%</span>');
            }
          });
        }, 4000);
      }
    }
  }
};

export default cartMethods;